<template>
	<div class="center">
		<form action="/" method="post" id="uploadForm" enctype="multipart/form-data">
			<div class="content_wrap">
				<div class="content">
					<div class="tit">
						<span>制作内容</span>
					</div>
					<div class="from_box">
						<!-- 标题 start -->
						<div class="inf_wrap">
							<div class="from_tit">
								<label for="ipt_tit">标题</label>
							</div>
							<div class="from_ipt regIpt">
								<input type="text" v-model="showPage.bg_title" id="ipt_tit" placeholder="例：一、整一整" name="textvalue">
								<div class="tishi">
                                    <span class="per_err"><i class="el-icon-warning"></i>标题不可为空</span>
                                    <span class="per_suc"><i class="el-icon-success"></i></span>
                                </div>
							</div>
							<div class="clearfix"></div>
						</div>
						<!-- 标题 end -->
						<!-- 音乐 start -->
						<div class="inf_wrap">
							<div class="from_tit">
								<label for="ipt_tit">音乐</label>
							</div>
							<div class="from_ipt from_text">           
						        <div class="file-box" @click="musicShow()">+添加音乐</div>
						    </div> 
							<div class="clearfix"></div>
						</div>
						<ul class="upload-list">
				            <li  v-for="(item, index) in showPage.music" class="upload-list-li">
				                <a class="upload-list-li-name">
				                	<label class="upload-list-li-label" @click="deleFile(index,item.name)"><i class="fa fa-trash-o"></i></label>
				                	<span>{{item.name}}</span>
				                	<div class="music_play_icon">
				                		<audio controls class="auto_audio"  :src="item.src" :type="item.type" crossOrigin="anonymous"></audio>
				                	</div>
				                </a>
				                
				            </li>
				        </ul>
				        <!-- 音乐 end -->

				        <!-- 文本、诗歌、视频、图片 start -->

				        <!-- 文本 start -->
						<div class="inf_wrap wb_txt">
							<div class="from_tit">
								<label for="ipt_tit">文本</label>
							</div>
							<div class="from_ipt area_text">
								<vue-ueditor-wrap v-model="moren" :config="myConfig" ref="ue" @ready="ready"></vue-ueditor-wrap>	
								<div class="upload-videos-wrap" style="z-index:1000;">
									<i class="icon-video" title="视频" @click="addvideo(1)"></i>
									<i class="icon-img" title="图片" @click="addimage(1)"></i>
								</div>			
							</div>
							<div class="clearfix"></div>
						</div>
						<!-- 文本 end -->
						
						<!-- 文本、诗歌、视频、图片 start -->
						<div class="inf_wrap">
							<div class="from_tit">
								<label for="ipt_tit">是否有教学详解</label>
							</div>
							<div class="from_switch">
								<div class="switch"  @click="changeZT">
									<span class="switch-D"></span>
								</div>
							</div>
							<div class="clearfix"></div>
						</div>
					</div>
					<!-- 备课详情 start -->
					<div class="pre_lesson" v-if="value1">
						<div class="bkxq_tit">
							<div class="tits">教学详解</div>
						</div>
						<div v-if="xianshiA" class="lesson_wrap lesson_wrap1" v-for="(item,key) in twoPage" :key="key">
							<div class="lesson_tit">
								<div class="new_add">
									<span @click="add_del(key)"><i class="el-icon-remove-outline"></i>删除</span>
								</div>
							</div>
							<div class="lesson_inf">
								<!-- 备课标题 start -->
								<div class="inf_wrap">
									<div class="from_tit">
										<label for="ipt_tit">标题</label>
									</div>
									<div class="from_ipt bk_ipt">
										<input type="text" id="ipt_tit" class="ipt_tit" placeholder="例：一、整一整" v-model="item.title">
										<div class="tishi">
		                                    <span class="per_err"><i class="el-icon-warning"></i>标题不可为空</span>
		                                    <span class="per_suc"><i class="el-icon-success"></i></span>
		                                    <span class="per_warn"><i class="el-icon-info">不可超过30个汉字</i></span>
		                                </div>
									</div>
									<div class="clearfix"></div>
								</div>
								<!-- 备课标题 end -->
								
								<!-- 备课音乐 start-->
								
								<div class="inf_wrap">
									<div class="from_tit">
										<label for="ipt_tit">音乐</label>
									</div>
									<div class="from_ipt from_text">           
								        <div class="file-box" @click="addmusic(key)">+添加音乐</div>
								    </div> 
									<div class="clearfix"></div>
								</div>
								<ul class="upload-list">
						            <li  v-for="(file, index) in item.music" class="upload-list-li">
						                <a class="upload-list-li-name">
						                	<label class="upload-list-li-label" @click="deleFiles(index,key)"><i class="fa fa-trash-o"></i></label>
						                	<span>{{file.name}}</span>
						                	<div class="music_play_icon"  @click="bkplayer(key,index)">
						                		<audio controls class="auto_audio"  :src="file.src" :type="file.type" crossOrigin="anonymous"></audio>
						                	</div>
						                </a>
						            </li>
						        </ul>

								<!-- 备课音乐  end -->

						        <!-- 备课文本 start -->

								<div class="inf_wrap wb_txt">
									<div class="from_tit">
										<label for="ipt_tit">文本</label>
									</div>
									<div class="from_ipt area_text1">
										<vue-ueditor-wraps v-model="item.list[0].content" :config="Config" ref="UE" @ready="changeready(key)"></vue-ueditor-wraps>	
										<div class="upload-videos-wrap" style="z-index:1000;">
											<i class="icon-video" title="视频" @click="addvideos(key,2)"></i>
											<i class="icon-img" title="图片" @click="addimages(key,2)"></i>
										</div>			
									</div>
									<div class="clearfix"></div>
								</div>
								<!-- 备课文本 end -->
							</div>
							<div class="vue-oss-uploader-video-wraps">
								<div class="vue-oss-uploader-video">
									<div class="vue-oss-uploader-video-top">
										<div class="vue-oss-uploader-video-top-left">视频</div>
										<div class="vue-oss-top-closes" @click="bkButtonClose(key)">×</div>
									</div>
									<div class="vue-oss-uploader-video-top-btn clearfixed">
										<div class="video-btn-local fl_left video-btn" @click="bkaddvideo(key)">上传视频</div>
										<div class="mark_wrap_loading"></div>
									</div>
									<div class="vue-oss-uploader-video-content">
										<div class="video-top-head clearfixed">
											<div class="fl_left video-sele-z">选择</div>
											<div class="fl_left video-sele-name">名称</div>
											<div class="fl_left video-sele-ntime">更新时间</div>
											<div class="fl_left video-sele-time">时长</div>
										</div>
										<div style="position:relative;">
											<div class="oss-video clearfixed" v-if="filesVideo" v-for=" (item,index) in filesVideo" @click="bkselectVideo(index,key)">
												<div class="fl_left video-sele-z" ><span class="checkedbox"></span><div class="mark"><i class="el-icon-check"></i></div></div>
												<div class="fl_left video-sele-name">{{item.name}}</div>
												<div class="fl_left video-sele-ntime">{{item.file.lastModifiedDate}}</div>
												<div class="fl_left video-sele-time">00:00:25</div>
												<div class="bkloading-wrap-video">
													<div class="progress_barVideo">
														<div class="fl_left progress_length"><input disabled :style="{width:proBar+'%'}" type="text"></div>
														<span class="fl_right uploadNum">已上传：0%</span>
													</div>
												</div>
											</div>
											<div class="oss-loading-mark-wrap"></div>
										</div>

									</div>
									<div class="videoBtn_wrap">
										<div class="videoBtn" @click="bkcheckVideo(key)">确定</div>
										<div class="mark_btn">上传中<img src="static/imgs/loading.gif" alt=""></div>
									</div>
									<input type="file" @change="bkfileChanged(key)" class="videoInput" ref="file1" name="file" multiple="multiple" accept="video/mp4">
								</div>
							</div>
							<div class="vue-oss-uploader-video-wrapw">
								<div class="vue-oss-uploader-video">
									<div class="vue-oss-uploader-video-top">
										<div class="vue-oss-uploader-video-top-left">图片</div>
										<div class="vue-oss-top-closes" @click="bkButtonclosez(key)">×</div>
									</div>
									<div class="vue-oss-uploader-video-top-btn clearfixed">
										<div class="video-btn-local fl_left video-btn" @click="bkaddimg(key)" v-if="status == 'ready'">上传图片</div>
									</div>
									<div class="vue-oss-uploader-video-content clearfixed">
										<div class="image-show fl_left" v-for="(item,index) in filesImages" @click="bkselectImage(index,key)">
											<img :src="item.src" alt="">
											<div class="mark">
												<i class="el-icon-check"></i>
											</div>
										</div>
									</div>
									<div class="addchangewrap">
										<div class="addswitchwrap fl_left"  @click="addchangeClass">
											<span class="addclasswitch-D"></span>
										</div>
										<div class="fl_left">是否在APP上可操作</div>
									</div>
									<div class="videoBtn" @click="bkcheckImage(key)">确定</div>
									<input type="file" @change="bkfileChangedz(key)" class="videoInput" name="file" ref="file2" multiple="multiple" accept="image/jpg,image/jpeg,image/png,image/bmp">
								</div>
							</div>
							<div class="vue-oss-uploader-video-wrapm">
								<div class="vue-oss-uploader-video">
									<div class="vue-oss-uploader-video-top">
										<div class="vue-oss-uploader-video-top-left">音乐</div>
										<div class="vue-oss-top-closes" @click="ButtonCloseBKMusic()">×</div>
									</div>
									<div class="vue-oss-uploader-video-top-btn clearfixed">
										<div class="video-btn-local fl_left video-btn" v-if="status == 'ready'" @click="bkaddmusic(key)">上传音乐</div>
										<div class="mark_wrap_loading"></div>
									</div>
									<div class="vue-oss-uploader-video-content">
										<div class="video-top-head clearfixed">
											<div class="fl_left video-sele-z">选择</div>
											<div class="fl_left video-sele-name">名称</div>
											<div class="fl_left video-sele-ntime">更新时间</div>
											<div class="fl_left video-sele-time">时长</div>
										</div>
										<div style="position:relative;">
											<div class="oss-video clearfixed" v-if="filesMusic" v-for=" (items,index) in filesMusic" @click="bkselectMusic(index,key)">
												<div class="fl_left bk-video-sele-m" ><span class="checkedbox"></span><div class="markmusic"><i class="el-icon-check"></i></div></div>
												<div class="fl_left video-sele-name">{{items.name}}</div>
												<div class="fl_left video-sele-ntime">{{items.file.lastModifiedDate}}</div>
												<div class="fl_left video-sele-time">00:00:25</div>
												<div class="bkloading-wrap-music">
													<div class="progress_barMusic">
														<div class="fl_left progress_length"><input disabled :style="{width:proBar+'%'}" type="text"></div>
														<span class="fl_right uploadNum">已上传：0%</span>
													</div>
												</div>
											</div>
											<div class="oss-loading-mark-wrap"></div>
										</div>
									</div>
									<div class="videoBtn_wrap">
										<div class="videoBtn" @click="bkcheckMusic(key)">确定</div>
										<div class="mark_btn">上传中<img src="static/imgs/loading.gif" alt=""></div>
									</div>
									<input type="file" id="files" name="file" class="videoInput" accept="audio/mp3" ref="file3"  multiple @change="tirggerFiles($event,key)">
								</div>
							</div>
						</div>
						<div v-if="xianshiB" class="lesson_wrap lesson_wrap2" v-for="(item,key) in bk_con" :key="key">
							<div class="lesson_tit">
								<div class="new_add">
									<span @click="bk_add_info()"><i class="el-icon-circle-plus-outline"></i>新增</span>
									<span @click="add_del(key)"><i class="el-icon-remove-outline"></i>删除</span>
								</div>
							</div>
							<div class="lesson_inf">
								<!-- 备课标题 start -->
								<div class="inf_wrap">
									<div class="from_tit">
										<label for="ipt_tit">标题</label>
									</div>
									<div class="from_ipt bk_ipt">
										<input type="text" id="ipt_tit" class="ipt_tit" placeholder="例：一、整一整" v-model="item.title">
										<div class="tishi">
		                                    <span class="per_err"><i class="el-icon-warning"></i>标题不可为空</span>
		                                    <span class="per_suc"><i class="el-icon-success"></i></span>
		                                    <span class="per_warn"><i class="el-icon-info">不可超过30个汉字</i></span>
		                                </div>
									</div>
									<div class="clearfix"></div>
								</div>
								<!-- 备课标题 end -->
								
								<!-- 备课音乐 start -->
								<div class="inf_wrap">
									<div class="from_tit">
										<label for="ipt_tit">音乐</label>
									</div>
									<div class="from_ipt from_text">           
								        <div class="file-box" @click="addmusic(key)">+添加音乐</div>  
								    </div> 
									<div class="clearfix"></div>
								</div>
								<ul class="upload-list">
						            <li  v-for="(file, index) in item.music" class="upload-list-li">
						                <a class="upload-list-li-name">
						                	<label class="upload-list-li-label" @click="deleFiles(index,key)"><i class="fa fa-trash-o"></i></label>
						                	<span>{{file.name}}</span>
						                	<div class="music_play_icon">
						                		<audio controls class="auto_audio"  :src="file.src" :type="file.type" crossOrigin="anonymous"></audio>
						                	</div>
						                </a>
						            </li>
						        </ul>
						
								<!-- 备课音乐  end -->
						
						        <!-- 备课文本 start -->
								<div class="inf_wrap wb_txt">
									<div class="from_tit">
										<label for="ipt_tit">文本</label>
									</div>
									<div class="from_ipt area_text1">
										<vue-ueditor-wraps v-model="item.list[0].content" :config="Config" ref="UE" @ready="changeready(key)"></vue-ueditor-wraps>	
										<div class="upload-videos-wrap" style="z-index:1000;">
											<i class="icon-video" title="视频" @click="addvideos(key)"></i>
											<i class="icon-img" title="图片" @click="addimages(key)"></i>
										</div>			
									</div>
									<div class="clearfix"></div>
								</div>
								<!-- 备课文本 end -->
							</div>
							<div class="vue-oss-uploader-video-wraps">
								<div class="vue-oss-uploader-video">
									<div class="vue-oss-uploader-video-top">
										<div class="vue-oss-uploader-video-top-left">视频</div>
										<div class="vue-oss-top-closes" @click="bkButtonClose(key)">×</div>
									</div>
									<div class="vue-oss-uploader-video-top-btn clearfixed">
										<div class="video-btn-local fl_left video-btn" @click="bkaddvideo(key)">上传视频</div>
										<div class="mark_wrap_loading"></div>
									</div>
									<div class="vue-oss-uploader-video-content">
										<div class="video-top-head clearfixed">
											<div class="fl_left video-sele-z">选择</div>
											<div class="fl_left video-sele-name">名称</div>
											<div class="fl_left video-sele-ntime">更新时间</div>
											<div class="fl_left video-sele-time">时长</div>
										</div>
										<div style="position:relative;">
											<div class="oss-video clearfixed" v-if="filesVideo" v-for=" (item,index) in filesVideo" @click="bkselectVideo(index,key)">
												<div class="fl_left video-sele-z" ><span class="checkedbox"></span><div class="mark"><i class="el-icon-check"></i></div></div>
												<div class="fl_left video-sele-name">{{item.name}}</div>
												<div class="fl_left video-sele-ntime">{{item.file.lastModifiedDate}}</div>
												<div class="fl_left video-sele-time">00:00:25</div>
												<div class="bkloading-wrap-video">
													<div class="progress_barVideo">
														<div class="fl_left progress_length"><input disabled :style="{width:proBar+'%'}" type="text"></div>
														<span class="fl_right uploadNum">已上传：0%</span>
													</div>
												</div>
											</div>
											<div class="oss-loading-mark-wrap"></div>
										</div>
									</div>
									<div class="videoBtn_wrap">
										<div class="videoBtn" @click="bkcheckVideo(key)" @keyup.enter="search">确定</div>
										<div class="mark_btn">上传中<img src="static/imgs/loading.gif" alt=""></div>
									</div>
									<input type="file" @change="bkfileChanged(key)" class="videoInput" ref="file1" multiple="multiple" accept="video/mp4">
								</div>
							</div>
							<div class="vue-oss-uploader-video-wrapw">
								<div class="vue-oss-uploader-video">
									<div class="vue-oss-uploader-video-top">
										<div class="vue-oss-uploader-video-top-left">图片</div>
										<div class="vue-oss-top-closes" @click="bkButtonclosez(key)">×</div>
									</div>
									<div class="vue-oss-uploader-video-top-btn clearfixed">
										<div class="video-btn-local fl_left video-btn" @click="bkaddimg(key)" v-if="status == 'ready'">上传图片</div>
									</div>
									<div class="vue-oss-uploader-video-content clearfixed">
										<div class="image-show fl_left" v-for="(item,index) in filesImages" @click="bkselectImage(index,key)">
											<img :src="item.src" alt="">
											<div class="mark">
												<i class="el-icon-check"></i>
											</div>
										</div>
									</div>
									<div class="addchangewrap">
										<div class="addswitchwrap fl_left"  @click="addchangeClass">
											<span class="addclasswitch-D"></span>
										</div>
										<div class="fl_left">是否在APP上可操作</div>
									</div>
									<div class="videoBtn" @click="bkcheckImage(key)">确定</div>
									<input type="file" @change="bkfileChangedz(key)" class="videoInput" ref="file2" multiple="multiple" accept="image/jpg,image/jpeg,image/png,image/bmp">
								</div>
							</div>
							<div class="vue-oss-uploader-video-wrapm">
								<div class="vue-oss-uploader-video">
									<div class="vue-oss-uploader-video-top">
										<div class="vue-oss-uploader-video-top-left">音乐</div>
										<div class="vue-oss-top-closes" @click="ButtonCloseBKMusic()">×</div>
									</div>
									<div class="vue-oss-uploader-video-top-btn clearfixed">
										<div class="video-btn-local fl_left video-btn" v-if="status == 'ready'" @click="bkaddmusic(key)">上传音乐</div>
										<div class="mark_wrap_loading"></div>
									</div>
									<div class="vue-oss-uploader-video-content">
										<div class="video-top-head clearfixed">
											<div class="fl_left video-sele-z">选择</div>
											<div class="fl_left video-sele-name">名称</div>
											<div class="fl_left video-sele-ntime">更新时间</div>
											<div class="fl_left video-sele-time">时长</div>
										</div>
										<div style="position:relative;">
											<div class="oss-video clearfixed" v-if="filesMusic" v-for=" (items,index) in filesMusic" @click="bkselectMusic(index,key)">
												<div class="fl_left bk-video-sele-m" ><span class="checkedbox"></span><div class="markmusic"><i class="el-icon-check"></i></div></div>
												<div class="fl_left video-sele-name">{{items.name}}</div>
												<div class="fl_left video-sele-ntime">{{items.file.lastModifiedDate}}</div>
												<div class="fl_left video-sele-time">00:00:25</div>
												<div class="bkloading-wrap-music">
													<div class="progress_barMusic">
														<div class="fl_left progress_length"><input disabled :style="{width:proBar+'%'}" type="text"></div>
														<span class="fl_right uploadNum">已上传：0%</span>
													</div>
												</div>
											</div>
											<div class="oss-loading-mark-wrap"></div>
										</div>
									</div>
									<div class="videoBtn_wrap">
										<div class="videoBtn" @click="bkcheckMusic(key)">确定</div>
										<div class="mark_btn">上传中<img src="static/imgs/loading.gif" alt=""></div>
									</div>
									<input type="file" id="files"  class="videoInput" accept="audio/mp3" ref="file3"  multiple @change="tirggerFiles($event,key)">
								</div>
							</div>
						</div>
						<div class="inf_wrap from-wrap-newadd">
							<div class="from_tit addnew_wrap">
								<label for="ipt_tit"></label>
							</div>
							<div class="newadd from_ipt">
								<el-button plain @click="bk_add_info()" class="newitem"> + 新增</el-button>
							</div>
							<div class="clearfix"></div>
						</div>
					</div>
					<!-- 备课详情 end -->
				</div>
				<div class="vue-oss-uploader-video-wrap" v-if="UPloads">
					<div class="vue-oss-uploader-video">
						<div class="vue-oss-uploader-video-top">
							<div class="vue-oss-uploader-video-top-left">{{title}}</div>
							<div class="vue-oss-top-closes" @click="ButtonClose()">×</div>
						</div>
						<div class="vue-oss-uploader-video-top-btn clearfixed">
							<div class="video-btn-local fl_left video-btn" @click="add" v-if="status == 'ready'" >上传{{title}}</div>
							<div class="loading_upload_mark" v-show="show"></div>
						</div>
						<div class="vue-oss-uploader-video-content">
							<div class="video-top-head clearfix">
								<div class="fl_left video-sele" style="width:20%">选择</div>
								<div class="fl_left video-sele" style="width:40%">名称</div>
								<div class="fl_left video-sele" style="width:40%">更新时间</div>
							</div>
							<div style="position:relative;">
								<div class="oss-video oss_loading_video clearfix" v-for=" (item,key) in files">
									<div class="fl_left video-sele video-sele-z"  @click="selectVideo(key,title)" style="width:20%;margin:0"><span class="checkedbox"></span><div class="mark"><i class="el-icon-check"></i></div></div>
									<div class="fl_left video-sele" style="width:40%">{{item.name}}</div>
									<div class="fl_left video-sele" style="width:40%">{{item.file.lastModifiedDate}}</div>
									<div class="loading_bar">
										<div class="progress_bar_load clearfix">
											<div class="fl_left progress_bar_div" :style="{width:proBar}"></div>
											<span class="fl_right">已上传：{{proBar}}</span>
										</div>
									</div>
								</div>
								<div class="oss-loading-mark" v-show="show"></div>
							</div>
						</div>
						<div class="videoBtn_wrap">
							<div class="videoBtn" @click="checkVideo">确定</div>
							<div class="mark_btns" v-show="show">上传中<img src="static/imgs/loading.gif" alt=""></div>
						</div>
						<input v-if="title == '音乐'" type="file" id="files"  class="videoInput" accept="audio/mp3" ref="file"  multiple @change="tirggerFile($event)">
						<input v-if="title == '视频'" type="file" @change="fileChanged" class="videoInput" ref="file" multiple="multiple" accept="video/mp4">
					</div>
				</div>
				<div class="vue-oss-uploader-video-wrap" v-if="UPloadz">
					<div class="vue-oss-uploader-video">
						<div class="vue-oss-uploader-video-top">
							<div class="vue-oss-uploader-video-top-left">图片</div>
							<div class="vue-oss-top-closes" @click="Buttonclosez()">×</div>
						</div>
						<div class="vue-oss-uploader-video-top-btn clearfix">
							<div class="video-btn-local fl_left video-btn" @click="add" v-if="status == 'ready'">上传图片</div>
						</div>
						<div class="vue-oss-uploader-video-content clearfix">
							<div class="image-show fl_left" v-for="(item,key) in files" @click="selectImage(key)">
								<img :src="item.src" alt="">
								<div class="mark">
									<i class="el-icon-check"></i>
								</div>
							</div>
						</div>
						<div class="addchangewrap">
							<div class="addswitchwrap fl_left"  @click="addchangeClass">
								<span class="addclasswitch-D"></span>
							</div>
							<div class="fl_left">是否在APP上可操作</div>
						</div>
						<div class="videoBtn" @click="checkImage">确定</div>
							<input type="file" @change="fileChangedz" class="videoInput" ref="file" multiple="multiple" accept="image/jpg,image/jpeg,image/png,image/bmp">
					</div>
				</div>
				<!-- <div class="vue-oss-uploader-video-wrap" v-if="UPloadw">
					<div class="vue-oss-uploader-video">
						<div class="vue-oss-uploader-video-top">
							<div class="vue-oss-uploader-video-top-left">音乐</div>
							<div class="vue-oss-top-closes" @click="ButtonCloseMusic()">×</div>
						</div>
						<div class="vue-oss-uploader-video-top-btn clearfixed">
							<div class="video-btn-local fl_left video-btn" @click="add" v-if="status == 'ready'">上传音乐</div>
							<div class="mark_wrap_loading"></div>
						</div>
						<div class="vue-oss-uploader-video-content">
							<div class="video-top-head clearfixed">
								<div class="fl_left video-sele-z">选择</div>
								<div class="fl_left video-sele-name">名称</div>
								<div class="fl_left video-sele-ntime">更新时间</div>
								<div class="fl_left video-sele-time">时长</div>
							</div>
							<div style="position:relative;">
								<div class="oss-video clearfixed" v-if="filesMusic" v-for=" (item,key) in filesMusic" @click="selectMusic(key)">
									<div class="fl_left video-sele-m" ><span class="checkedbox"></span><div class="markmusic"><i class="el-icon-check"></i></div></div>
									<div class="fl_left video-sele-name">{{item.name}}</div>
									<div class="fl_left video-sele-ntime">{{item.file.lastModifiedDate}}</div>
									<div class="fl_left video-sele-time">00:00:25</div>
									<div class="loading-wrap">
										<div id="progress_bar">
											<div class="fl_left progress_length"><input disabled :style="{width:proBar+'%'}" type="text"></div>
											<span class="fl_right uploadNum">已上传：0%</span>
										</div>
									</div>
								</div>
								<div class="oss-loading-mark-wrap"></div>
							</div>
						</div>
						<div class="videoBtn_wrap">
							<div class="videoBtn" @click="checkMusic">确定</div>
							<div class="mark_btn">上传中<img src="static/imgs/loading.gif" alt=""></div>
						</div>
						<input type="file" id="files"  class="videoInput" accept="audio/mp3" ref="file" name="file"  multiple @change="tirggerFile($event)">
					</div>
				</div> -->
			</div>
		</form>
		<div class="preservaation">
			<div class="preservaation-li">
				<span @click="stro()" class="btn">保存</span>
				<span @click="GoBack()" class="btn brn-back">返回</span>
			</div>
		</div>
	</div>
</template>
<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import VueUeditorWraps from 'vue-ueditor-wrap'
	export default {
		name: 'imageView',
		data(){
			return{
				key:'',      //tw下标
				index:'',    //one/two
				show:false,   //loading状态
				list :[],      //存储所有舞种、期、课节id
				title:'视频',   //上传弹窗显示title
				token:'',   //分片上传token
				files:[],    //存储视频、图片、音频
				loading:false,  //loading状态
				proBar:0,     //进度条
				shows:false,


				creyId:'',
				xianshiA:true,
				xianshiB:false,
				showPage:[],
				twoPage:[],
				showPageDetal:'',
				moren:'',
				music_state:0,
				UPloads:false,
				UPloadw:false,
				UPloadz:false,
				status: 'ready',
       			value1: 0,
        		filesMusic:[],
        		filesImages:[],
        		filesVideo:[],
        		text:'',
        		course:'',
        		bk_con:[
	        		{
	        			type:0,
	        			title:'',
	        			list:[
	        				{
	        					content:''
	        				}
	        			],
	        			music:[]
	        		}
        		],
        		templateId:"",
        		myConfig: {
		            // 如果需要上传功能,找后端小伙伴要服务器接口地址
		            // serverUrl: 'https://yizi-kejian.oss-cn-beijing.aliyuncs.com/kjzz/resources/images',
		            // 你的UEditor资源存放的路径,相对于打包后的index.html
		            UEDITOR_HOME_URL:'./static/UEditor/',
		            // 编辑器不自动被内容撑高
		            autoHeightEnabled: false,
		            // 初始容器高度
		            initialFrameHeight: 260,
		            // 初始容器宽度
		            initialFrameWidth: 650,
		            // 关闭自动保存
		            enableAutoSave: false,
		            //启用自动保存
		            pasteplain:true ,//是否默认为纯文本粘贴。false为不使用纯文本粘贴，true为使用纯文本粘贴
			        // enableAutoSave: true,
			        //自动保存间隔时间， 单位ms
			        // saveInterval: 500
			        autoSyncData:true,
			        //菜单按钮
			        toolbars: [[
			        	'fullscreen', 'undo', 'redo', '|','bold', 'italic', 'underline', 'pasteplain', '|','rowspacingtop', 'rowspacingbottom', 'lineheight', '|', 'forecolor', 'insertorderedlist', 'insertunorderedlist', '|', 'paragraph', 'fontfamily', 'fontsize', '|','justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'insertimage'
			        ]],
			        elementPathEnabled:false,
			        wordCount:false,
		        },
       			Config: {
		            // 你的UEditor资源存放的路径,相对于打包后的index.html
		            UEDITOR_HOME_URL: './static/UEditor/',
		            // 编辑器不自动被内容撑高
		            autoHeightEnabled: false,
		            // 初始容器高度
		            initialFrameHeight: 260,
		            // 初始容器宽度
		            initialFrameWidth: 650,
		            // 关闭自动保存
		            enableAutoSave: false,
		            //启用自动保存
			        // enableAutoSave: true,
			        //自动保存间隔时间， 单位ms
			        // saveInterval: 500
			        autoSyncData:true,
			        //菜单按钮
			        pasteplain:true ,//是否默认为纯文本粘贴。false为不使用纯文本粘贴，true为使用纯文本粘贴
			        toolbars: [[
			        	'fullscreen', 'undo', 'redo', '|','bold', 'italic', 'underline', 'pasteplain', '|','rowspacingtop', 'rowspacingbottom', 'lineheight', '|', 'forecolor', 'insertorderedlist', 'insertunorderedlist', '|', 'paragraph', 'fontfamily', 'fontsize', '|','justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'insertimage'
			        ]],
			        elementPathEnabled:false,
			        wordCount:false
		        },
		        toId:'',
		        bd_img:'',
		        bdvideoSrc:'',
		        bd_video:'',
		        bd_img:'',
		        num:0,
		        proBar:0,
		        Jhimg:'',
		        fileListCon:[],
		        bkfileListCon:[],
		        sum:0,
		        time:0,
		        currentAjax:null,
			}
		},
		components:{
			VueUeditorWrap,
			VueUeditorWraps
		},
		mounted(){
			const _this=this;
			if(this.value1){
				$('.switch-D').animate({
					left:'19px'
				})
				$('.switch').addClass('switchB');
			}else{
				$('.switch-D').animate({
					left:'1px'
				})
				$('.switch').removeClass('switchB');
			}
			history.pushState(null, null, document.URL);
			if (window.history && window.history.pushState) {
			    history.pushState(null, null, document.URL);
			    window.addEventListener('popstate', this.GoBack, false);
		  	}
		},
		methods:{
			addchangeClass(){
				if($('.addclasswitch-D').css('left')=='1px'){
					$('.addclasswitch-D').animate({
						left:'19px'
					})
					$('.addswitchwrap').addClass('switchB');
				}else{
					$('.addclasswitch-D').animate({
						left:'1px'
					})
					$('.addswitchwrap').removeClass('switchB');
				}
			},
			GoBack(){
				const _this=this;
				if(_this.showPage.bg_title == ''){
					this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
				}else{
					this.$confirm('此操作将放弃修改内容, 是否继续?', '提示', {
			          	onfirmButtonText: '确定',
			          	cancelButtonText: '取消',
			         	type: 'warning'
			     	}).then(() => {
			          // 	this.$message({
				         //    type: 'success',
				         //    message: '取消保存!'
			         	// });
			         	this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
			        })
				}
				// this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
			},
			ready(editorInstance){
				$(this.$refs.ue.editor.body).css({'background':'#f4f4f4'})
				this.$refs.ue.editor.body.innerHTML=this.showPage.bg_text
			},
			changeready(i){
				$(this.$refs.UE[i].editor.body).css({'background':'#f4f4f4'})
			},
			changeZT(){
				this.value1=!this.value1
				if(this.value1){
					if(this.showPageDetal){
						this.xianshiA=true;
						this.xianshiB=false;
					}else{
						this.xianshiA=false;
						this.xianshiB=true;
					}
					$('.switch-D').animate({
						left:'19px'
					})
					$('.switch').addClass('switchB');
				}else{
					$('.switch-D').animate({
						left:'1px'
					})
					$('.switch').removeClass('switchB');
				}
			},
			// addmusic(i){
			// 	const _this=this;
			// 	$('.lesson_wrap').eq(i).find('.vue-oss-uploader-video-wrapm').show().parent().parent().siblings().find('.vue-oss-uploader-video-wrapm').hide()
			// },
			ButtonCloseBKMusic(){
				const _this=this;
				if(_this.currentAjax==null){
					$('.vue-oss-uploader-video-wrapm').hide()
				}else{
					_this.currentAjax.abort();
					$('.oss-loading-mark-wrap').hide()
	            	$('.mark_btn').hide()
	            	$('.mark_wrap_loading').hide()
	            	$('.vue-oss-uploader-video-wrapm').hide()
					$('.markmusic').hide()
					$('.bkloading-wrap-music').hide();
				}
            },
            bkButtonclosez(key){
            	$('.vue-oss-uploader-video-wrapw').hide()
            },
			musicShow(i){
				let _this = this;
				_this.UPloads  = true
				_this.index = i;
				_this.title = "音乐"
				_this.get_music()
			},
			// ButtonCloseMusic(){
			// 	const _this=this;
			// 	if(_this.currentAjax==null){
			// 		this.UPloadw =!this.UPloadw;
			// 	}else{
			// 		_this.currentAjax.abort()
			// 		$('.mark_wrap_loading').hide()
	  //           	$('.oss-loading-mark-wrap').hide()
	  //           	$('.mark_btn').hide()
			// 		this.UPloadw =!this.UPloadw;
			// 	}
			// },
			// showMusicLength(){
			// 	const _this=this;
			// 	var Package=parseInt(JSON.parse(sessionStorage.getItem('lessonInfor')).pocId)
			// 	_this.filesMusic=[];
   //          	_this.$axios.post('getAllMedia',{
			// 		type:'audio',
			// 		course_id:this.course,
			// 		package_id:Package
			// 	}).then(({data:{data}})=>{
			// 		//console.log(data)
			// 		for(var i=0;i<data.length;i++){
			// 			_this.filesMusic.push({
			// 				name:data[i].media_title,
			// 				file:{lastModifiedDate:data[i].updated_at},
			// 				src:data[i].res_url,
			// 				url:'../../media/'+data[i].new_file_name
			// 			})
			// 		}
			// 		sessionStorage.setItem('NumLength',_this.filesMusic.length)
			// 	})
			// },
			// bkselectMusic(i,j){
			// 	const _this=this;
			// 	$('.vue-oss-uploader-video-wrapm').eq(j).find('.oss-video').eq(i).find('.bk-video-sele-m').children('.markmusic').show().parent().parent().siblings().find('.bk-video-sele-m').children('.markmusic').hide();
			// 	this.num=i;
			// 	this.time=new Date().getTime()
			// },
			// bkcheckMusic(i){
			// 	const _this=this;
			// 	if(_this.filesMusic.length<=parseInt(sessionStorage.getItem('NumLength'))){
			// 		if(!_this.xianshiA){
	  //           		_this.bk_con[i].music.push({"src":_this.filesMusic[_this.num].src,"url":_this.filesMusic[_this.num].url,'name':_this.filesMusic[_this.num].name})
	  //           	}else{
	  //           		if(typeof(_this.twoPage[i].music)=='undefined'){
	  //           			_this.twoPage[i].music=[];
	  //           			_this.twoPage[i].music.push({"src":_this.filesMusic[_this.num].src,"url":_this.filesMusic[_this.num].url,'name':_this.filesMusic[_this.num].name})
	  //           		}else{
	  //           			_this.twoPage[i].music.push({"src":_this.filesMusic[_this.num].src,"url":_this.filesMusic[_this.num].url,'name':_this.filesMusic[_this.num].name})
	  //           		}
	  //           	}
			// 		$('.oss-loading-mark-wrap').hide()
	  //           	$('.mark_btn').hide()
	  //           	$('.mark_wrap_loading').hide()
	  //           	$('.vue-oss-uploader-video-wrapm').hide()
			// 		$('.markmusic').hide()
			// 		$('.bkloading-wrap-music').hide();
			// 		_this.num='';
			// 	}else{
	  //           	const listInf=JSON.parse(localStorage.getItem('template'))
	  //               const fNum = _this.filesMusic;
			// 		const formData = new FormData();
			// 		formData.append('file', fNum[this.num].file)
			// 		formData.append('course_id', parseInt(listInf.course_id))
			// 		formData.append('package_id', parseInt(listInf.package_id))
			// 		formData.append('less_id', parseInt(listInf.table_id))
			// 		formData.append('file_name','audio_'+_this.time)
			// 		formData.append("title",fNum[_this.num].name)
	  //               _this.currentAjax=$.ajax({
			//             type: "post",
			//             url:  strUrl + "upload",      // 北舞正式服
			//             data: formData,
			//             dataType: 'json',
			//             processData: false, // 告诉jQuery不要去处理发送的数据
			//             contentType: false, // 告诉jQuery不要去设置Content-Type请求头
			//             xhrFields:{withCredentials:true},
			//             async: true,    //默认是true：异步，false：同步。
			//             xhr: function(){
			// 		       const  myXhr = $.ajaxSettings.xhr();
			// 		        if(myXhr.upload){
			// 		          myXhr.upload.addEventListener('progress',function(e) {
			// 		            if (e.lengthComputable) {
			// 		              var percent = Math.floor(e.loaded/e.total*100);
			// 		              if(percent <= 100) {
			// 		              	$('.vue-oss-uploader-video-wrapm').eq(i).find('.oss-video').eq(_this.num).find('.bkloading-wrap-music').css({"display":"flex"}).parent().siblings().find('.bkloading-wrap-music').hide();
			// 		                $(".progress_barMusic span").html('已上传：'+percent+'%');
			// 		                $('.mark_btn').css({'display':'flex'})
			// 		                $('.mark_wrap_loading').show()
			// 		                $('.oss-loading-mark-wrap').show()
			// 		                _this.proBar=percent;
			// 		              }
			// 		            }
			// 		          }, false);
			// 		        }
			// 		        return myXhr;
			// 		    },
			//             success: function (res) {
			//             	if(res.code == 200){
			//             		if(!_this.xianshiA){
			// 	            		_this.bk_con[i].music.push({"src":res.data,"url":'../../media/audio_'+_this.time+'.mp3','name':fNum[_this.num].name})
			// 	            	}else{
			// 	            		if(typeof(_this.twoPage[i].music)=='undefined'){
			// 	            			_this.twoPage[i].music=[];
			// 	            			_this.twoPage[i].music.push({"src":res.data,"url":'../../media/audio_'+_this.time+'.mp3','name':fNum[_this.num].name})
			// 	            		}else{
			// 	            			_this.twoPage[i].music.push({"src":res.data,"url":'../../media/audio_'+_this.time+'.mp3','name':fNum[_this.num].name})
			// 	            		}
			// 	            	}
			//             	}
			//             	else{
			//             		_this.$message.error(res.message)
			//             	}
			            	
			//             	_this.showMusicLength()
			//             	$('.oss-loading-mark-wrap').hide()
			//             	$('.mark_btn').hide()
			//             	$('.mark_wrap_loading').hide()
			//             	$('.vue-oss-uploader-video-wrapm').hide()
			// 				$('.markmusic').hide()
			// 				$('.bkloading-wrap-music').hide();
			//             },
			//             error: function (data) {
			//                 console.log(data);
			//             },
			//         });
	  //           }
			// },
			// selectMusic(i){
			// 	$('.vue-oss-uploader-video-wrap').find('.oss-video').eq(i).find('.video-sele-m').children('.markmusic').show().parent().parent().siblings().find('.video-sele-m').children('.markmusic').hide();
			// 	this.num=i;
			// 	this.time=new Date().getTime()
			// },
			// checkMusic(){
			// 	const _this=this;
			// 	if(_this.filesMusic.length<=parseInt(sessionStorage.getItem('NumLength'))){
			// 		_this.showPage.music.push({"src":_this.filesMusic[_this.num].src,"url":_this.filesMusic[_this.num].url,'name':_this.filesMusic[_this.num].name});
			// 		_this.UPloadw =!_this.UPloadw;
			// 	}else{
	  //           	const listInf=JSON.parse(localStorage.getItem('template'))
	  //               const fNum = this.filesMusic;
			// 		const formData = new FormData();
			// 		formData.append('file', fNum[_this.num].file)
			// 		formData.append('course_id', parseInt(listInf.course_id))
			// 		formData.append('package_id', parseInt(listInf.package_id))
			// 		formData.append('less_id', parseInt(listInf.table_id))
			// 		formData.append('file_name','audio_'+_this.time)
			// 		formData.append("title",fNum[_this.num].name)
	  //               _this.currentAjax=$.ajax({
			//             type: "post",
			//             url:  strUrl + "upload",      // 北舞正式服
			//             data: formData,
			//             dataType: 'json',
			//             processData: false, // 告诉jQuery不要去处理发送的数据
			//             contentType: false, // 告诉jQuery不要去设置Content-Type请求头
			//             xhrFields:{withCredentials:true},
			//             async: true,    //默认是true：异步，false：同步。
			//             xhr: function(){
			// 		       const  myXhr = $.ajaxSettings.xhr();
			// 		        if(myXhr.upload){
			// 		          myXhr.upload.addEventListener('progress',function(e) {
			// 		            if (e.lengthComputable) {
			// 		              var percent = Math.floor(e.loaded/e.total*100);
			// 		              if(percent <= 100) {
			// 		              	$('.mark_wrap_loading').show()
			// 		              	$('.vue-oss-uploader-video-wrap').find('.oss-video').eq(_this.num).find('.loading-wrap').css({"display":"flex"}).parent().siblings().find('.loading-wrap').hide();
			// 		                $("#progress_bar span").html('已上传：'+percent+'%');
			// 		                $('.mark_btn').css({'display':'flex'})
			// 		                $('.oss-loading-mark-wrap').show()
			// 		                _this.proBar=percent;
			// 		              }
			// 		            }
			// 		          }, false);
			// 		        }
			// 		        return myXhr;
			// 		    },
			//             success: function (res) {
			//             	if(res.code == 200){
			//             	//console.log(data)
			// 	            	_this.showPage.music.push({'src':res.data,'url':'../../media/audio_'+_this.time+'.mp3','name':fNum[_this.num].name});
			// 	            }
			// 	            else{
			// 	            	_this.$message.error(res.message)
			// 	            }
			//             	//console.log(_this.showPage.music)
			//             	_this.showMusicLength()
			//             	_this.UPloadw =!_this.UPloadw;
			//             	$('.mark_wrap_loading').hide()
			//             	$('.oss-loading-mark-wrap').hide()
			//             	$('.mark_btn').hide()
			//             },
			//             error: function (data) {
			//                 console.log(data);
			//             },
			//         });
	  //           }
			// },
			// showVideoLength(){
			// 	const _this=this;
			// 	var Package=parseInt(JSON.parse(sessionStorage.getItem('lessonInfor')).pocId)
			// 	_this.filesVideo=[];
			// 	_this.$axios.post('getAllMedia',{
			// 		type:'video',
			// 		course_id:this.course,
			// 		package_id:Package
			// 	}).then(({data:{data}})=>{
			// 		//console.log(data)
			// 		for(var i=0;i<data.length;i++){
			// 			_this.filesVideo.push({
			// 				name:data[i].media_title,
			// 				file:{lastModifiedDate:data[i].updated_at},
			// 				src:data[i].res_url,
			// 				url:'../../media/'+data[i].new_file_name
			// 			})
			// 		}
			// 		sessionStorage.setItem('videoNumLength',_this.filesVideo.length)
			// 	})
			// },
		    // selectVideo(i){
		    // 	const _this=this;
		    // 	$('.vue-oss-uploader-video-wrap .vue-oss-uploader-video .vue-oss-uploader-video-content').find('.oss-video').eq(i).find('.video-sele-z').children('.mark').show().parent().parent().siblings().find('.video-sele-z').children('.mark').hide();
		    // 	this.num=i;
		    // 	this.time=new Date().getTime();
		    // 	this.bdvideoSrc='../../media/video_'+this.time+'.mp4';
		    // },
		    createIMG(){
		    	const _this=this;
                var scale = 0.5,
                video = $(this.$refs.ue.editor.body).find('#video').find('video')[0],
                canvas = document.createElement("canvas"),
                canvasFill = canvas.getContext('2d');
                /*canvas.width = video.videoWidth * scale;;
                canvas.height = video.videoHeight * scale;;*/
                canvas.width = 346;
                canvas.height = 230;
                canvasFill.drawImage(video, 0, 0, canvas.width, canvas.height);
                var src = canvas.toDataURL("image/jpeg");
                var blob = this.dataURLtoBlob(src, "image/png")
                var file = new File([blob], "video_image"+new Date().getTime()+".png", { type: "image/png", lastModified: Date.now() })
                const listInf=JSON.parse(localStorage.getItem('template'))
                _this.fileListCon.push({file})
                var fNum=_this.fileListCon
				const formData = new FormData();
				formData.append('file', fNum[this.num].file)
				formData.append('course_id', parseInt(listInf.course_id))
				formData.append('package_id', parseInt(listInf.package_id))
				formData.append('less_id', parseInt(listInf.table_id))
				formData.append('file_name',fNum[this.num].file.name.substring(0,fNum[this.num].file.name.lastIndexOf('.')))
				formData.append("title",fNum[_this.num].name)
                $.ajax({
		            type: "post",
		            url:  strUrl + "upload",      // 北舞正式服
		            data: formData,
		            dataType: 'json',
		            processData: false, // 告诉jQuery不要去处理发送的数据
		            contentType: false, // 告诉jQuery不要去设置Content-Type请求头
		            xhrFields:{withCredentials:true},
		            async: true,    //默认是true：异步，false：同步。
		            success: function ({data}) {
		            	_this.Jhimg='../../media/'+fNum[_this.num].file.name
		            	$(_this.$refs.ue.editor.body).find('#video').remove()
		            },
		            error: function (data) {
		                console.log(data);
		            }
		        });
            },
            dataURLtoBlob(dataURI,type) {
				var binary = atob(dataURI.split(',')[1]);
				var array = [];
				for(var i = 0; i < binary.length; i++) {
					array.push(binary.charCodeAt(i));
				}
				return new Blob([new Uint8Array(array)], {type:type});
			},
		  //   checkVideo(){
		  //   	const _this=this;
		  //   	if(_this.filesVideo.length<=parseInt(sessionStorage.getItem('videoNumLength'))){
				// 	_this.Jhimg='../../media/'+_this.filesVideo[_this.num].url.substring(_this.filesVideo[_this.num].url.lastIndexOf("/")+1).split('.')[0]+'.png'
				// 	_this.$refs.ue.editor.execCommand('insertHtml',"<p>.<video onclick='playPuase()' preload='auto' width='230' height='156' src='"+_this.filesVideo[_this.num].src+"' data-src='"+_this.filesVideo[_this.num].url+"' data-url='"+ _this.Jhimg +"' controls></video>.</p></br>")
				// 	_this.UPloads=!_this.UPloads;
				// }else{
			 //    	$(this.$refs.ue.editor.body).append('<div id="video" class="w50"></div>')
	   //              var files = this.$refs.file.files,
		  //               video = $(this.$refs.ue.editor.body).find('#video').find('video'),
		  //               videoURL = null,
		  //               windowURL = window.URL || window.webkitURL;
	   //              if (files && files[0]) {
	   //                  videoURL = windowURL.createObjectURL(files[0]);
	   //                  $(this.$refs.ue.editor.body).find('#video').append('<video src="' + videoURL + '" controls style="display:none"></video>');
	   //                  setTimeout(function() {
	   //                      _this.createIMG();
	   //                  }, 500);
	   //              }
	   //          	const listInf=JSON.parse(localStorage.getItem('template'))
	   //              const fNum = this.filesVideo;
				// 	const formData = new FormData();
				// 	formData.append('file', fNum[_this.num].file)
				// 	formData.append('course_id', parseInt(listInf.course_id))
				// 	formData.append('package_id', parseInt(listInf.package_id))
				// 	formData.append('less_id', parseInt(listInf.table_id))
				// 	formData.append('file_name','video_'+_this.time)
				// 	formData.append("title",fNum[_this.num].name)
	   //              _this.currentAjax=$.ajax({
			 //            type: "post",
			 //            url:  strUrl + "upload",      // 北舞正式服
			 //            data: formData,
			 //            dataType: 'json',
			 //            processData: false, // 告诉jQuery不要去处理发送的数据
			 //            contentType: false, // 告诉jQuery不要去设置Content-Type请求头
			 //            xhrFields:{withCredentials:true},
			 //            async: true,    //默认是true：异步，false：同步。
			 //            xhr: function(){
				// 	       const  myXhr = $.ajaxSettings.xhr();
				// 	        if(myXhr.upload){
				// 	          myXhr.upload.addEventListener('progress',function(e) {
				// 	            if (e.lengthComputable) {
				// 	              var percent = Math.floor(e.loaded/e.total*100);
				// 	              if(percent <= 100) {
				// 	              	$('.vue-oss-uploader-video-wrap').find('.oss-video').eq(_this.num).find('.loading-wrap1').css({"display":"flex"}).parent().siblings().find('.loading-wrap1').hide();
				// 	                $("#progress_bar1 span").html('已上传：'+percent+'%');
				// 	                $('.mark_btn').css({'display':'flex'})
				// 	                $('.oss-loading-mark-wrap').show()
				// 	                $('.mark_wrap_loading').show()
				// 	                _this.proBar=percent;
				// 	              }
				// 	            }
				// 	          }, false);
				// 	        }
				// 	        return myXhr;
				// 	    },
			 //            success: function (res) {
			 //            	if(res.code == 200){
			 //            		 _this.$refs.ue.editor.execCommand('insertHtml','<p>.<video preload="auto" src="'+res.data+'" data-src="'+_this.bdvideoSrc+'" width="230" height="156" controls data-url="'+_this.Jhimg+'"></video>.</p></br>')
			 //            	}
			 //            	else{
			 //            		_this.$message.error(res.message)
			 //            	}
			 //            	//console.log(_this.$refs.ue.editor.body.innerHTML)
				           
				//             _this.showVideoLength()
			 //            	/*_this.moren=_this.moren+'<p><video src="'+data+'" data-src="'+_this.bdvideoSrc+'" width="230" height="156" controls data-url="'+_this.Jhimg+'"></video></p><p></br></p>'*/
			 //            	_this.UPloads=!_this.UPloads;
			 //            	$('.oss-loading-mark-wrap').hide()
			 //            	$('.mark_btn').hide()
			 //            	$('.mark_wrap_loading').hide()
			 //            },
			 //            error: function (data) {
			 //                console.log(data);
			 //            },
			 //        });  
	   //          }
		  //   },
		  	//视频与音乐选择
		    selectVideo(i,title){
		    	const _this=this;
		    	$('.vue-oss-uploader-video-wrap').find('.oss-video').eq(i).find('.video-sele-z').children('.mark').show().parent().parent().siblings().find('.video-sele-z').children('.mark').hide();
	    		_this.num = i;
	    		_this.time = new Date().getTime();
		    	if(title == '视频'){
			    	this.bdvideoSrc='../../media/video_'+new Date().getTime()+'.mp4';
		    	}
		    },
		    
		    //上传视频/音乐
			checkVideo(){
				const _this=this;
				if(_this.files[_this.num].id){
					if(_this.title == "视频"){
						if(_this.index == 1){
							_this.Jhimg='../../media/'+_this.files[_this.num].url.substring(_this.files[_this.num].url.lastIndexOf("/")+1).split('.')[0]+'.png'
							_this.$refs.ue.editor.execCommand('insertHtml',"<p>.<video preload='auto' width='230' height='156' src='"+_this.files[_this.num].src+"' data-src='"+_this.files[_this.num].url+"' data-url='"+ _this.Jhimg +"' controls></video>.</p></br>")
						}
						else if(_this.index == 2){
							_this.Jhimg='../../media/'+_this.files[_this.num].url.substring(_this.files[_this.num].url.lastIndexOf("/")+1).split('.')[0]+'.png'
				    		_this.$refs.UEs[_this.key].editor.execCommand('insertHtml',"<p>.<video preload='auto' src='"+_this.files[_this.num].src+"' data-src='"+_this.files[_this.num].url+"' width='230' height='156' controls data-url='"+ _this.Jhimg +"'></video>.</p></br>");
					        _this.bk_con[_this.key].list[0].content=_this.$refs.UEs[_this.key].editor.body.innerHTML
						}
						
					}
					else if(_this.title == "音乐"){
						if(_this.index == 1){
							_this.fileList.push({"src":_this.files[_this.num].src,"url":_this.files[_this.num].url,'name':_this.files[_this.num].name});
						}
						else if(_this.index == 2){
							_this.bk_con[_this.key].music.push({"src":_this.files[_this.num].src,"url":_this.files[_this.num].url,'name':_this.files[_this.num].name})
						}
					}
					_this.UPloads = false
				}
				else{
					if(_this.title == "视频"){
						if(_this.index == 1){
							$(this.$refs.ue.editor.body).append('<div id="video" class="w50"></div>')
			                var files = this.$refs.file.files,
				                video = $(this.$refs.ue.editor.body).find('#video').find('video'),
				                videoURL = null,
				                windowURL = window.URL || window.webkitURL;
			                if (files && files[0]) {
			                    videoURL = windowURL.createObjectURL(files[0]);
			                    $(this.$refs.ue.editor.body).find('#video').append('<video src="' + videoURL + '" controls style="display:none"></video>');
			                    setTimeout(function() {
			                        _this.createIMG();
			                    }, 1000);
			                }
						}
						else if(_this.index == 2){
							$(this.$refs.UEs[this.key].editor.body).append('<p id="video" class="w50"></p>')
			                var files = this.$refs.file.files,
				                video = $(this.$refs.UEs[this.key].editor.body).find('#video').find('video'),
				                videoURL = null,
				                windowURL = window.URL || window.webkitURL;
			                if (files && files[0]) {
			                    videoURL = windowURL.createObjectURL(files[0]);
			                    $(this.$refs.UEs[this.key].editor.body).find('#video').append('<video src="' + videoURL + '" controls style="display:none"></video>');
			                    setTimeout(function() {
			                        _this.bkcreateIMG();
			                    }, 1000);
			                }
						}
		            }
	                const fNum = this.files;
					_this.$axios.post('upload/video',{course_id:_this.list.course_id,package_id:_this.list.package_id,table_id:_this.list.table_id,name:fNum[_this.num].file.name,size:fNum[_this.num].file.size,type:"video"}).then( res =>{
						if(res.data.code == 200){
							_this.token = res.data.data.token
							_this.proBar = 0
							_this.show = true
							$('.oss_loading_video').eq(_this.num).find('.loading_bar').show().parent().siblings().find('.loading_bar').hide()
							_this.upload_section(fNum[_this.num].file,1,_this.key)
						}
						else{
							_this.$message.error(res.data.message)
						}
					}).catch( error =>{
						console.log(error)
					})   
				}
		    },

		    //切片上传视频/音乐
			upload_section(file, num ,i){
				let _this = this;
	            var blockSize =  2 * 1024 * 1024;
	            var start = (num - 1) * blockSize;
	            var blockNum = Math.ceil(file.size / blockSize);    //总片数
	            var nextSize = Math.min(num * blockSize, file.size);   //下一片的位置
	            var fileData = file.slice((num - 1) * blockSize, nextSize);   //
	            _this.currentAjax=$.ajax({
	                url: strUrl + "upload/up?token="+_this.token + '&up_size='+start,
	                type: "POST",
	                data: fileData,
	                processData: false,
	                contentType: 'application/json',
	                success: function (responseText) {
	                	_this.proBar = Math.floor((num * 100) / blockNum) + '%'
	                    if (file.size <= nextSize) {
	                    	_this.show = false;
	                    	_this.$message.success("上传成功")
	                    	_this.bd_video = '../../media'+responseText.data.webFilePath.substr(responseText.data.webFilePath.lastIndexOf('/'))
	                    	if(_this.title == "视频"){
	                    		if(_this.index == 1){
	                    			_this.$refs.ue.editor.execCommand('insertHtml',"<p>.<video  preload='auto' width='230' height='156' src='"+responseText.data.webFilePath+"' data-src='"+_this.bd_video+"' data-url='"+ _this.Jhimg +"' controls></video>.</p></br>");
	                    		}
	                    		else if(_this.index == 2){
	                    			_this.$refs.UEs[i].editor.execCommand('insertHtml',"<p>.<video preload='auto' src='"+responseText.data.webFilePath+"' data-src='"+_this.bd_video+"' width='230' height='156' controls data-url='"+ _this.Jhimg +"'></video>.</p></br>");
		            				_this.bk_con[i].list[0].content=_this.$refs.UEs[i].editor.body.innerHTML
	                    		}
	                    		
	                    		_this.get_video()
	                    	}
	                    	else if(_this.title == "音乐"){
	                    		if(_this.index == 1){
	                    			_this.fileList.push({'src':responseText.data.webFilePath,'url':_this.bd_video,'name':file.name});
	                    		}
	                    		else if(_this.index == 2){
	                    			_this.bk_con[i].music.push({"src":responseText.data.webFilePath,"url":_this.bd_video,'name':file.name})
	                    		}
	                    		_this.get_music()
	                    	}
			            	_this.num = '';
			            	_this.UPloads = false
	                        return;
	                    }
	                   _this.upload_section(file, ++num, i);//递归调用
	                }
	            });
			},

		    // bkselectVideo(i,j){
		    // 	const _this=this;
		    // 	$('.vue-oss-uploader-video-wraps').eq(j).find('.oss-video').eq(i).find('.video-sele-z').children('.mark').show().parent().parent().siblings().find('.video-sele-z').children('.mark').hide();
		    // 	this.num=i;
		    // 	this.sum=j;
		    // 	this.time=new Date().getTime();
		    // 	this.bd_video='../../media/video_'+this.time+'.mp4'
		    // },
		    bkcreateIMG(){
		    	const _this=this;
                var scale = 0.5,
                video = $(this.$refs.UE[this.sum].editor.body).find('#video').find('video')[0],
                canvas = document.createElement("canvas"),
                canvasFill = canvas.getContext('2d');
                /*canvas.width = video.videoWidth * scale;;
                canvas.height = video.videoHeight * scale;;*/
                canvas.width = 346;
                canvas.height = 230;
                canvasFill.drawImage(video, 0, 0, canvas.width, canvas.height);
                var src = canvas.toDataURL("image/jpeg");
                var blob = this.dataURLtoBlob(src, "image/png")
                var file = new File([blob], "video_image"+new Date().getTime()+".png", { type: "image/png", lastModified: Date.now() })
                const listInf=JSON.parse(localStorage.getItem('template'))
                _this.bkfileListCon.push({file})
                var fNum=_this.bkfileListCon
				const formData = new FormData();
				formData.append('file', fNum[fNum.length-1].file)
				formData.append('course_id', parseInt(listInf.course_id))
				formData.append('package_id', parseInt(listInf.package_id))
				formData.append('less_id', parseInt(listInf.table_id))
				formData.append('file_name',fNum[this.num].file.name.substring(0,fNum[fNum.length-1].file.name.lastIndexOf('.')))
				formData.append("title",fNum[_this.num].name)
                $.ajax({
		            type: "post",
		            url:  strUrl + "upload",      // 北舞正式服
		            data: formData,
		            dataType: 'json',
		            processData: false, // 告诉jQuery不要去处理发送的数据
		            contentType: false, // 告诉jQuery不要去设置Content-Type请求头
		            xhrFields:{withCredentials:true},
		            async: true,    //默认是true：异步，false：同步。
		            success: function ({data}) {
		            	_this.Jhimg='../../media/'+fNum[fNum.length-1].file.name
		            	$(_this.$refs.UE[_this.sum].editor.body).find('#video').remove()
		            },
		            error: function (data) {
		                console.log(data);
		            }
		        });
            },
		   //  bkcheckVideo(i){
		   //  	const _this=this;
		   //  	if(_this.filesVideo.length<=parseInt(sessionStorage.getItem('videoNumLength'))){
		   //  		_this.Jhimg='../../media/'+_this.filesVideo[_this.num].url.substring(_this.filesVideo[_this.num].url.lastIndexOf("/")+1).split('.')[0]+'.png'
		   //  		if(!_this.xianshiA){
	    //         		_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<p>.<video preload='auto' src='"+_this.filesVideo[_this.num].src+"' data-src='"+_this.filesVideo[_this.num].url+"' width='230' height='156' controls data-url='"+ _this.Jhimg +"'></video>.</p></br>");
			  //      		 _this.bk_con[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
	    //         	}else{
	    //         		_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<p>.<video preload='auto' src='"+_this.filesVideo[_this.num].src+"' data-src='"+_this.filesVideo[_this.num].url+"' width='230' height='156' controls data-url='"+ _this.Jhimg +"'></video>.</p></br>");
	    //         		_this.twoPage[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
	    //         	}
		   //  		$('.oss-loading-mark-wrap').hide()
	    //         	$('.mark_btn').hide()
	    //         	$('.mark_wrap_loading').hide()
	    //         	$('.vue-oss-uploader-video-wraps').hide()
	    // 			$('.mark').hide();
	    // 			$('.bkloading-wrap-video').hide();
		   //  	}else{
			  //   	$(this.$refs.UE[this.sum].editor.body).append('<p id="video" class="w50"></p>')
	    //             var files = this.$refs.file1[this.sum].files,
		   //              video = $(this.$refs.UE[this.sum].editor.body).find('#video').find('video'),
		   //              videoURL = null,
		   //              windowURL = window.URL || window.webkitURL;
		                
	    //             if (files && files[0]) {
	    //                 videoURL = windowURL.createObjectURL(files[0]);
	    //                 $(this.$refs.UE[this.sum].editor.body).find('#video').append('<video src="' + videoURL + '" controls style="display:none"></video>');
	    //                 setTimeout(function() {
	    //                     _this.bkcreateIMG();
	    //                 }, 500);
	    //             }
	    //         	const listInf=JSON.parse(localStorage.getItem('template'))
	    //             const fNum = this.filesVideo;
					// const formData = new FormData();
					// formData.append('file', fNum[_this.num].file)
					// formData.append('course_id', parseInt(listInf.course_id))
					// formData.append('package_id', parseInt(listInf.package_id))
					// formData.append('less_id', parseInt(listInf.table_id))
					// formData.append('file_name','video_'+_this.time)
					// formData.append("title",fNum[_this.num].name)
	    //             _this.currentAjax=$.ajax({
			  //           type: "post",
			  //           url:  strUrl + "upload",      // 北舞正式服
			  //           data: formData,
			  //           dataType: 'json',
			  //           processData: false, // 告诉jQuery不要去处理发送的数据
			  //           contentType: false, // 告诉jQuery不要去设置Content-Type请求头
			  //           xhrFields:{withCredentials:true},
			  //           async: true,    //默认是true：异步，false：同步。
			  //           xhr: function(){
					//        const  myXhr = $.ajaxSettings.xhr();
					//         if(myXhr.upload){
					//           myXhr.upload.addEventListener('progress',function(e) {
					//             if (e.lengthComputable) {
					//               	var percent = Math.floor(e.loaded/e.total*100);
					//               	if(percent <= 100) {
					//               		$('.vue-oss-uploader-video-wraps').eq(i).find('.oss-video').eq(_this.num).find('.bkloading-wrap-video').css({"display":"flex"}).parent().siblings().find('.bkloading-wrap-video').hide();
					// 	                $(".progress_barVideo span").html('已上传：'+percent+'%');
					// 	                $('.mark_btn').css({'display':'flex'})
					// 	                $('.oss-loading-mark-wrap').show()
					// 	                $('.mark_wrap_loading').show()
					// 	                _this.proBar=percent;
					//               	}
					//             }
					//           }, false);
					//         }
					//         return myXhr;
					//     },
			  //           success: function (res) {
			  //           	if(res.code == 200){
				 //            	if(!_this.xianshiA){
				 //            		_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<p>.<video preload='auto' src='"+res.data+"' data-src='"+_this.bd_video+"' width='230' height='156' controls data-url='"+_this.Jhimg+"'></video>.</p></br>")
				 //            		_this.bk_con[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
				 //            	}else{
				 //            		_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<p>.<video preload='auto' src='"+res.data+"' data-src='"+_this.bd_video+"' width='230' height='156' controls data-url='"+_this.Jhimg+"'></video>.</p></br>")
				 //            		_this.twoPage[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
				 //            	}
			  //           	}
			  //           	else{
			  //           		_this.$message.error(res.message)
			  //           	}

			  //           	_this.showVideoLength()
			  //           	$('.oss-loading-mark-wrap').hide()
			  //           	$('.mark_btn').hide()
			  //           	$('.mark_wrap_loading').hide()
			  //           	$('.vue-oss-uploader-video-wraps').hide()
			  //   			$('.mark').hide();
			  //   			$('.bkloading-wrap-video').hide();
			  //           },
			  //           error: function (data) {
			  //               console.log(data);
			  //           },
			  //       });
	    //         }
		   //  },
		    // selectImage(i){
		    // 	$('.vue-oss-uploader-video-wrap').find('.image-show').eq(i).find('.mark').show().parent().siblings().children('.mark').hide();
		    // 	this.time=new Date().getTime()
		    // 	this.num=i;
		    // },
		   //  checkImage(){
		   //  	const _this=this;
		   //  	if(_this.filesImages.length<=parseInt(sessionStorage.getItem('ImgNumLength'))){
		   //  		if($('.addclasswitch-D').css('left')=='1px'){
	    //         		_this.$refs.ue.editor.execCommand('insertHtml',"<img style='width:230px;height:156px;' src='"+_this.filesImages[_this.num].src+"' data-src='"+_this.filesImages[_this.num].url+"'></img>")
     //        		}else{
     //        			_this.$refs.ue.editor.execCommand('insertHtml',"<img class='changebox' style='width:230px;height:156px;' src='"+_this.filesImages[_this.num].src+"' data-src='"+_this.filesImages[_this.num].url+"'></img>")
     //        			$('.addclasswitch-D').animate({
					// 		left:'1px'
					// 	})
					// 	$('.addswitchwrap').removeClass('switchB');
     //        		}
		   //  		_this.UPloadz=!_this.UPloadz;
		   //  	}else{
	    //         	const listInf=JSON.parse(localStorage.getItem('template'))
	    //             const fNum = this.filesImages;
					// const formData = new FormData();
					// formData.append('file', fNum[_this.num].file)
					// formData.append('course_id', parseInt(listInf.course_id))
					// formData.append('package_id', parseInt(listInf.package_id))
					// formData.append('less_id', parseInt(listInf.table_id))
					// formData.append('file_name','image_'+_this.time)
					// formData.append("title",fNum[_this.num].name)
	    //             $.ajax({
			  //           type: "post",
			  //           url:  strUrl + "upload",      // 北舞正式服
			  //           data: formData,
			  //           dataType: 'json',
			  //           processData: false, // 告诉jQuery不要去处理发送的数据
			  //           contentType: false, // 告诉jQuery不要去设置Content-Type请求头
			  //           xhrFields:{withCredentials:true},
			  //           async: true,    //默认是true：异步，false：同步。
			  //           success: function (res) {
			  //           	if(res.code == 200){
				 //            	_this.bd_img='../../media'+res.data.substr(res.data.lastIndexOf('/'))
				 //            	if($('.addclasswitch-D').css('left')=='1px'){
				 //            		_this.$refs.ue.editor.execCommand('insertHtml',"<img style='width:230px;height:156px;' src='"+res.data+"' data-src='"+_this.bd_img+"'></img>")
			  //           		}else{
			  //           			_this.$refs.ue.editor.execCommand('insertHtml',"<img class='changebox' style='width:230px;height:156px;' src='"+res.data+"' data-src='"+_this.bd_img+"'></img>")
			  //           			$('.addclasswitch-D').animate({
					// 					left:'1px'
					// 				})
					// 				$('.addswitchwrap').removeClass('switchB');
			  //           		}
			  //           	}
		   //          		else{
			  //           		_this.$message.error(res.message)
			  //           	}
			  //           	_this.showImageLength()
			  //               _this.UPloadz=!_this.UPloadz;
			  //           },
			  //           error: function (data) {
			  //               console.log(data);
			  //           },
			  //       });
	    //         }
		   //  },
		   //  bkselectImage(i,j){
		   //  	$('.vue-oss-uploader-video-wrapw').eq(j).find('.image-show').eq(i).find('.mark').show().parent().siblings().children('.mark').hide();
		   //  	this.time=new Date().getTime()
		   //  	this.num=i;
		   //  	this.sum=j;
		   //  },
		   //  bkcheckImage(i){
		   //  	const _this=this;
		   //  	if(_this.filesImages.length<=parseInt(sessionStorage.getItem('ImgNumLength'))){
		   //  		if($('.addclasswitch-D').css('left')=='1px'){
	    //         		_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<img style='width:230px;height:156px;' src='"+_this.filesImages[this.num].src+"' data-src='"+_this.filesImages[this.num].url+"'></img>")
     //        		}else{
     //        			_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<img class='changebox' style='width:230px;height:156px;' src='"+_this.filesImages[this.num].src+"' data-src='"+_this.filesImages[this.num].url+"'></img>")
     //        			$('.addclasswitch-D').animate({
					// 		left:'1px'
					// 	})
					// 	$('.addswitchwrap').removeClass('switchB');
     //        		}
		   //  		if(!_this.xianshiA){
			  //       	_this.bk_con[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
			  //   	}else{
			  //   		_this.twoPage[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
			  //   	}
		   //  		$('.vue-oss-uploader-video-wrapw').hide()
			  //       $('.mark').hide()
		   //  	}else{
	    //         	const listInf=JSON.parse(localStorage.getItem('template'))
	    //             const fNum = this.filesImages;
					// const formData = new FormData();
					// formData.append('file', fNum[_this.num].file)
					// formData.append('course_id', parseInt(listInf.course_id))
					// formData.append('package_id', parseInt(listInf.package_id))
					// formData.append('less_id', parseInt(listInf.table_id))
					// formData.append('file_name','image_'+_this.time)
					// formData.append("title",fNum[_this.num].name)
	    //             $.ajax({
			  //           type: "post",
			  //           url:  strUrl + "upload",      // 北舞正式服
			  //           data: formData,
			  //           dataType: 'json',
			  //           processData: false, // 告诉jQuery不要去处理发送的数据
			  //           contentType: false, // 告诉jQuery不要去设置Content-Type请求头
			  //           xhrFields:{withCredentials:true},
			  //           async: true,    //默认是true：异步，false：同步。
			  //           success: function (res) {
			  //           	if(res.code == 200){
				 //            	_this.bd_img='../../media'+res.data.substr(res.data.lastIndexOf('/'))
				 //            	if($('.addclasswitch-D').css('left')=='1px'){
				 //            		_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<img style='width:230px;height:156px;' src='"+res.data+"' data-src='"+_this.bd_img+"'></img>")
			  //           		}else{
			  //           			_this.$refs.UE[_this.sum].editor.execCommand('insertHtml',"<img class='changebox' style='width:230px;height:156px;' src='"+res.data+"' data-src='"+_this.bd_img+"'></img>")
			  //           			$('.addclasswitch-D').animate({
					// 					left:'1px'
					// 				})
					// 				$('.addswitchwrap').removeClass('switchB');
			  //           		}
				 //            	if(!_this.xianshiA){
				 //            		_this.bk_con[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
					// 	    	}else{
					// 	    		_this.twoPage[i].list[0].content=_this.$refs.UE[_this.sum].editor.body.innerHTML
					// 	    	}
					//     	}
		   //          		else{
			  //           		_this.$message.error(res.message)
			  //           	}
					//     	$('.mark').hide();
			  //   			$('.vue-oss-uploader-video-wrapw').hide()
			  //           },
			  //           error: function (data) {
			  //               console.log(data);
			  //           },
			  //       });
	    //         }
		   //  },


		    selectImage(i){
		    	$('.vue-oss-uploader-video-wrap').find('.image-show').eq(i).find('.mark').show().parent().siblings().children('.mark').hide();
		    	this.time=new Date().getTime()
		    	this.num=i;
		    },
		    checkImage(){
		    	const _this=this;
		    	if(_this.files[_this.num].id){
		    		if(_this.index == 1){
		    			if($('.addclasswitch-D').css('left')=='1px'){
		    			_this.$refs.ue.editor.execCommand('insertHtml','<img style="width:230px;height:156px;" src="'+_this.files[_this.num].src+'" data-src="'+_this.files[_this.num].url+'"></img>')
			    		}else{
			    			_this.$refs.ue.editor.execCommand('insertHtml','<img class="changebox" style="width:230px;height:156px;" src="'+_this.files[_this.num].src+'" data-src="'+_this.files[_this.num].url+'"></img>')
			    		}
		    		}
		    		else if(_this.index == 2){
		    			if($('.addclasswitch-D').css('left')=='1px'){
			    			_this.$refs.UEs[_this.key].editor.execCommand('insertHtml',"<img style='width:230px;height:156px;' src='"+_this.files[this.num].src+"' data-src='"+_this.files[this.num].url+"'></img>")
				    	}else{
				    		_this.$refs.UEs[_this.key].editor.execCommand('insertHtml',"<img class='changebox' style='width:230px;height:156px;' src='"+_this.files[this.num].src+"' data-src='"+_this.files[this.num].url+"'></img>")
				    		$('.addclasswitch-D').animate({
								left:'1px'
							})
							$('.addswitchwrap').removeClass('switchB');
				    	}
			        	_this.bk_con[_this.key].list[0].content=_this.$refs.UEs[_this.key].editor.body.innerHTML
		    		}
		    		
		    		_this.UPloadz=false
		    	}else{
		    		// const listInf=JSON.parse(localStorage.getItem('template'))
	                const fNum = this.files;
					// const formData = new FormData();
					// formData.append('file', fNum[_this.num].file)
					// formData.append('course_id', _this.list.course_id)
					// formData.append('package_id', _this.list.package_id)
					// formData.append('less_id', _this.list.table_id)
					// formData.append('file_name','image_'+_this.time)
					// formData.append("title",fNum[_this.num].name)
					_this.$axios.post('upload/video',{course_id:_this.list.course_id,package_id:_this.list.package_id,table_id:_this.list.table_id,name:fNum[_this.num].file.name,size:fNum[_this.num].file.size,type:"video"}).then( res =>{
						if(res.data.code == 200){
							_this.token = res.data.data.token
							// _this.proBar = 0
							// _this.show = true
							// $('.oss_loading_video').eq(_this.num).find('.loading_bar').show().parent().siblings().find('.loading_bar').hide()
							_this.upload_image(fNum[_this.num].file,1,_this.key)
						}
						else{
							_this.$message.error(res.data.message)
						}
					}).catch( error =>{
						console.log(error)
					})   
		    	}
		    },
		    upload_image(file, num , i){
		    	let _this = this;
	            var blockSize =  2 * 1024 * 1024;
	            var start = (num - 1) * blockSize;
	            var blockNum = Math.ceil(file.size / blockSize);    //总片数
	            var nextSize = Math.min(num * blockSize, file.size);   //下一片的位置
	            var fileData = file.slice((num - 1) * blockSize, nextSize);   //
	            _this.currentAjax=$.ajax({
	                url: strUrl + "upload/up?token="+_this.token + '&up_size='+start,
	                type: "POST",
	                data: fileData,
	                processData: false,
	                contentType: 'application/json',
	                success: function (responseText) {
	                	_this.proBar = Math.floor((num * 100) / blockNum) + '%'
	                    if (file.size <= nextSize) {
	                    	_this.show = false;
	                    	_this.$message.success("上传成功")
	                    	_this.bd_img='../../media'+responseText.data.webFilePath.substr(responseText.data.webFilePath.lastIndexOf('/'))
                    		if(_this.index == 1){
				            	if($('.addclasswitch-D').css('left')=='1px'){
					            	_this.$refs.ue.editor.execCommand('insertHtml',"<img style='width:230px;height:156px;' src='"+responseText.data.webFilePath+"' data-src='"+_this.bd_img+"'></img>")
					            }else{
					            	_this.$refs.ue.editor.execCommand('insertHtml',"<img class='changebox' style='width:230px;height:156px;' src='"+responseText.data.webFilePath+"' data-src='"+_this.bd_img+"'></img>")
					            }
                    		}
                    		else if(_this.index == 2){
				            	if($('.addclasswitch-D').css('left')=='1px'){
				            		_this.$refs.UEs[i].editor.execCommand('insertHtml',"<img style='width:230px;height:156px;' src='"+responseText.data.webFilePath+"' data-src='"+_this.bd_img+"'></img>")
				            	}else{
				            		_this.$refs.UEs[i].editor.execCommand('insertHtml',"<img class='changebox' style='width:230px;height:156px;' src='"+responseText.data.webFilePath+"' data-src='"+_this.bd_img+"'></img>")
				            		$('.addclasswitch-D').animate({
										left:'1px'
									})
									$('.addswitchwrap').removeClass('switchB');
				            	}
				            	_this.bk_con[i].list[0].content=_this.$refs.UEs[_this.sum].editor.body.innerHTML
                    		}
                    		_this.get_image()
	                
			            	_this.num = '';
			            	_this.UPloadz = false
	                        return;
	                    }
	                   _this.upload_image(file, ++num, i);//递归调用
	                }
	            });
		    },
			bk_add_info(){
				if(!this.xianshiA){
					this.bk_con.push({
						type:0,
						title:'',
						list:[
							{
								content:''
							}
						],
						music:[],	
					})
				}else{
					this.twoPage.push({
						type:0,
						title:'',
						list:[
							{
								content:''
							}
						],
						music:[],
					})
				}
			},
			add_del(i){
				if(!this.xianshiA){
					if(this.bk_con.length>1){
						var _this=this;
						this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				          	onfirmButtonText: '确定',
				          	cancelButtonText: '取消',
				         	type: 'warning'
				     	}).then(() => {
				          	this.$message({
					            type: 'success',
					            message: '删除成功!'
				         	});
				         	_this.bk_con.splice(i,1)
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消删除'
				          });          
				        });
					}else{
						var _this=this;
						this.$confirm('此操作将关闭教学详解, 是否继续?', '提示', {
				          	onfirmButtonText: '确定',
				          	cancelButtonText: '取消',
				         	type: 'warning'
				     	}).then(() => {
				          	this.$message({
					            type: 'success',
					            message: '关闭成功!'
				         	});
				         	_this.value1=false;
				         	this.xb=0;
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消关闭'
				          });          
				        });
					}
				}else{
					if(this.twoPage.length>1){
						var _this=this;
						this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				          	onfirmButtonText: '确定',
				          	cancelButtonText: '取消',
				         	type: 'warning'
				     	}).then(() => {
				          	this.$message({
					            type: 'success',
					            message: '删除成功!'
				         	});
				         	_this.twoPage.splice(i,1)
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消删除'
				          });          
				        });
					}else{
						var _this=this;
						this.$confirm('此操作将关闭教学详解, 是否继续?', '提示', {
				          	onfirmButtonText: '确定',
				          	cancelButtonText: '取消',
				         	type: 'warning'
				     	}).then(() => {
				          	this.$message({
					            type: 'success',
					            message: '关闭成功!'
				         	});
				         	_this.value1=false;
				         	this.xb=0;
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消关闭'
				          });          
				        });
					}
				}
			},
			//上传视频
			addvideo(i){
				const _this=this;
				_this.index = i;
				_this.UPloads = true
				_this.title = "视频"
				_this.get_video()
			},

			//上传图片
			addimage(i){
				const _this=this;
				_this.index = i;
				_this.UPloadz =! _this.UPloadz;
				_this.title = "图片"
				_this.get_image()
			},
			addvideos(i,j){
				const _this=this;
				_this.index = j;
				_this.key = i;
				_this.UPloads = true;
				_this.title = "视频"
				// $('.lesson_wrap').eq(i).find('.vue-oss-uploader-video-wraps').show().parent().parent().siblings().find('.vue-oss-uploader-video-wraps').hide()
				_this.get_video()
			},
			addmusic(i,j){
				const _this=this;
				_this.key = i;
				_this.index = j;
				_this.UPloads  = true
				_this.title = "音乐"
				// $('.lesson_wrap').eq(i).find('.vue-oss-uploader-video-wrapm').show().parent().parent().siblings().find('.vue-oss-uploader-video-wrapm').hide()
				_this.get_music()
			},
			addimages(i,j){
				const _this=this;
				_this.index = j;
				_this.key = i;
				_this.UPloadz  = true
				_this.title = "图片"
				_this.get_image()
			},

			// addvideos(i,j){
			// 	const _this=this;
			// 	$('.lesson_wrap').eq(i).find('.vue-oss-uploader-video-wraps').show().parent().parent().siblings().find('.vue-oss-uploader-video-wraps').hide()
			// },
			// addimages(i,j){
			// 	$('.lesson_wrap').eq(i).find('.vue-oss-uploader-video-wrapw').show().parent().parent().siblings().find('.vue-oss-uploader-video-wrapw').hide()
			// },
		    stro(){
		    	const _this=this;
		    	var list = JSON.parse(sessionStorage.getItem('formID'))
	    		if(_this.showPage.bg_title==''){
		    		this.$message({
		    			message:'请将信息填写完整',
		    			showClose:true,
		    			type:'waring'
		    		})
		    	}else{
		    		if(_this.value1==true){
		    			if(_this.showPage.bg_title.length<=0){
	    					$('.regIpt').find('#ipt_tit').addClass('per_warning').siblings().find('.per_warn').show().siblings().hide().parent().siblings().removeClass('per_success per_error')
	                        return false;
	    				}else{
	    					$('.regIpt').find('#ipt_tit').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_warning per_error')
	    					var one_title=JSON.stringify(_this.textvalue)
			    			var one_title=JSON.stringify(_this.showPage.bg_title)
			    			var one_music=JSON.stringify(_this.showPage.music)
			    			//console.log(_this.$refs.ue.editor.body.innerText)
			    			if(_this.$refs.ue.editor.body.innerHTML==="<p><br></p>"){
			    				_this.moren=''
			    			}else{
			    				_this.moren=_this.$refs.ue.editor.body.innerHTML 
			    			} 
			    			var one_text=JSON.stringify(_this.moren)
			    			if(this.$route.query.tit==1){
			    				this.routeAxios(1)
			    			}else if(this.$route.query.tit==2){
			    				this.routeAxios(2)
			    			}else{
			    				_this.$axios.post('editmodone',{
				    				id:list.conId,
				    				json_data:'{"bg_title":'+one_title+',"bg_text":'+one_text+',"music":'+one_music+'}',
				    				is_detail:1
				    			}).then(({data})=>{
				    				if(!_this.xianshiA){
				    					if(_this.bk_con[0].title.length==0){
					    					$('.bk_ipt').find('.ipt_tit').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_success per_warning')
					    					return false;
					    				}else{
					    					$('.bk_ipt').find('.ipt_tit').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_warning per_error')
					    					const json_str=JSON.stringify(_this.bk_con)
					    					_this.$axios.post('addmodtwo',{
					    						to_id:list.conId,
					    						tm_id:list.crey,
					    						json_data:'{"detal":'+json_str+'}',
					    						template_id:_this.creyId
					    					}).then((res)=>{
					    						if(res.data.code==200){
					    							_this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
					    						}
					    					})
					    				}
				    				}else{
				    					if(_this.twoPage[0].title.length>30){
					    					$('.bk_ipt').find('.ipt_tit').addClass('per_warning').siblings().find('.per_warn').show().siblings().hide().parent().siblings().removeClass('per_success per_error')
				                            return false;
					    				}else if(_this.twoPage[0].title.length==0){
					    					$('.bk_ipt').find('.ipt_tit').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_success per_warning')
					    					return false;
					    				}else{
					    					$('.bk_ipt').find('.ipt_tit').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_warning per_error')
					    					var json_str=JSON.stringify(_this.twoPage)
					    					_this.$axios.post('editmodtwo',{
					    						id:_this.toId,
					    						json_data:'{"detal":'+json_str+'}'
					    					}).then((res)=>{
					    						if(res.data.code==200){
					    							_this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
					    						}
					    					})
					    				}
				    				}
				    			})
			    			}
				    	}
		    		}else{
		    			if(_this.showPage.bg_title.length<=0){
	    					$('.regIpt').find('#ipt_tit').addClass('per_warning').siblings().find('.per_warn').show().siblings().hide().parent().siblings().removeClass('per_success per_error')
                            return false;
	    				}else{
	    					$('.regIpt').find('#ipt_tit').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_warning per_error')
		    				var one_title=JSON.stringify(_this.showPage.bg_title)
			    			var one_music=JSON.stringify(_this.showPage.music)
			    			//console.log(_this.$refs.ue.editor)
			    			if(_this.$refs.ue.editor.body.innerHTML==="<p><br></p>"){
			    				_this.moren=''
			    				//console.log(_this.$refs.ue.editor.body.innerText)
			    			}else{
			    				_this.moren=_this.$refs.ue.editor.body.innerHTML 
			    				//console.log(_this.$refs.ue.editor.body.innerText)
			    			}  
			    			var one_text=JSON.stringify(_this.moren)
			    			if(this.$route.query.tit==1){
			    				_this.axiosOne(1)
			    			}else if(this.$route.query.tit==2){
			    				_this.axiosOne(2)
			    			}else{
			    				_this.$axios.post('editmodone',{
				    				id:list.conId,
				    				json_data:'{"bg_title":'+one_title+',"bg_text":'+one_text+',"music":'+one_music+'}',
				    				is_detail:0
				    			}).then(({data})=>{
				    				if(data.code==200){
				    					_this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
				    				}
				    			})
			    			}
			    		}
		    		}
		    	}
		    },
		    routeAxios(i){
		    	let _this=this;
		    	var list = JSON.parse(sessionStorage.getItem('formID'))
		    	var one_title=JSON.stringify(_this.textvalue)
    			var one_title=JSON.stringify(_this.showPage.bg_title)
    			var one_music=JSON.stringify(_this.showPage.music)
    			if(_this.$refs.ue.editor.body.innerHTML==="<p><br></p>"){
    				_this.moren=''
    			}else{
    				_this.moren=_this.$refs.ue.editor.body.innerHTML 
    			}
    			var one_text=JSON.stringify(_this.moren)
    			_this.$axios.post('editmodone',{
    				id:list.conId, 
    				json_data:'{"bg_new":'+i+',"bg_title":'+one_title+',"bg_text":'+one_text+',"music":'+one_music+'}',
    				is_detail:1
    			}).then(({data})=>{
    				if(!_this.xianshiA){
    					if(_this.bk_con[0].title.length==0){
	    					$('.bk_ipt').find('.ipt_tit').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_success per_warning')
	    					return false;
	    				}else{
	    					$('.bk_ipt').find('.ipt_tit').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_warning per_error')
	    					const json_str=JSON.stringify(_this.bk_con)
	    					_this.$axios.post('addmodtwo',{
	    						to_id:list.conId,
	    						tm_id:list.crey,
	    						json_data:'{"detal":'+json_str+'}',
	    						template_id:_this.creyId
	    					}).then((res)=>{
	    						if(res.data.code==200){
	    							_this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
	    						}
	    					})
	    				}
    				}else{
    					if(_this.twoPage[0].title.length==0){
	    					$('.bk_ipt').find('.ipt_tit').addClass('per_error').siblings().find('.per_err').show().siblings().hide().parent().siblings().removeClass('per_success per_warning')
	    					return false;
	    				}else{
	    					$('.bk_ipt').find('.ipt_tit').addClass('per_success').siblings().find('.per_suc').show().siblings().hide().parent().siblings().removeClass('per_warning per_error')
	    					var json_str=JSON.stringify(_this.twoPage)
	    					_this.$axios.post('editmodtwo',{
	    						id:_this.toId,
	    						json_data:'{"detal":'+json_str+'}'
	    					}).then((res)=>{
	    						if(res.data.code==200){
	    							_this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
	    						}
	    					})
	    				}
    				}
    			})
		    },
		    axiosOne(i){
		    	let _this=this;
		    	var list = JSON.parse(sessionStorage.getItem('formID'))
		    	var one_title=JSON.stringify(_this.showPage.bg_title)
    			var one_music=JSON.stringify(_this.showPage.music)
    			if(_this.$refs.ue.editor.body.innerHTML==="<p><br></p>"){
    				_this.moren=''
    			}else{
    				_this.moren=_this.$refs.ue.editor.body.innerHTML 
    			} 
    			var one_text=JSON.stringify(_this.moren)
    			_this.$axios.post('editmodone',{
    				id:list.conId,
    				json_data:'{"bg_new":'+i+',"bg_title":'+one_title+',"bg_text":'+one_text+',"music":'+one_music+'}',
    				is_detail:0
    			}).then(({data})=>{
    				if(data.code==200){
    					_this.$router.replace({path:'/addCategory/makTep',name:'makTep',query:{id:this.$route.query.id,table_id:this.$route.query.table_id,package:this.$route.query.package,courseId:this.$route.query.courseid,pocId:this.$route.query.pocId}});
    				}
    			})
		    },
		    tirggerFile(event){
                var _this=this;
                const list = event.target.files;
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        _this.html5Reader(list[i], item)
                        _this.files.unshift(item)
                    }
                }
            },
            deleFile(i,name){
                this.showPage.music.splice(i,1);
            },
            bkaddmusic(i){
            	this.$refs.file3[i].click();
            },
            tirggerFiles(event,i){
                var _this=this;
                const list=this.$refs.file3[i].files            
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        _this.html5Reader(list[i], item)
                        this.files.unshift(item)
                        
                    }
                }
            },
            deleFiles(i,j){
            	let _this=this;
            	if(!_this.xianshiA){
            		_this.bk_con[j].music.splice(i,1);
            	}else{
            		_this.twoPage[j].music.splice(i,1);
            	}
            },
            bkaddimg(i) {
	           this.$refs.file2[i].click();
            },
            bkaddvideo(i) {
	            this.$refs.file1[i].click();
            },
            add() {
            	var _this=this;
	            _this.$refs.file.click();
            },
            ButtonClose(){
            	const _this=this;
            	if(_this.currentAjax==null){
            		this.UPloads =! this.UPloads;
            	}else{
            		_this.currentAjax.abort();
	            	$('.oss-loading-mark-wrap').hide()
	            	$('.mark_btn').hide()
	            	$('.mark_wrap_loading').hide()
	            	this.UPloads =! this.UPloads;
            	}
            },
            Buttonclosez(){
            	this.UPloadz =! this.UPloadz;
            },
            bkButtonClose(key){
            	const _this=this;
            	if(_this.currentAjax==null){
            		$('.vue-oss-uploader-video-wraps').hide()
            	}else{
            		_this.currentAjax.abort()
	            	$('.oss-loading-mark-wrap').hide()
	            	$('.mark_btn').hide()
	            	$('.mark_wrap_loading').hide()
	            	$('.vue-oss-uploader-video-wraps').hide()
	    			$('.mark').hide();
	    			$('.bkloading-wrap-video').hide();
            	}
            },
            bkButtonclosez(key){
            	$('.vue-oss-uploader-video-wrapw').hide()
            },
            //  时间戳
            timestamp:function(){  
                const time = new Date();  
                const y = time.getFullYear();  
                const m = time.getMonth()+1;  
                const d = time.getDate();  
                const h = time.getHours();  
                const mm = time.getMinutes();  
                const s = time.getSeconds();  
                const ms = time.getMilliseconds()  
                return ""+y+this.Add0(m)+this.Add0(d)+this.Add0(h)+this.Add0(mm)+this.Add0(s)+this.Add0(ms);  
            },
            Add0:function(m){  
                return m<10?'0'+m : m;  
            } ,
            fileChangedz() {
                const list = this.$refs.file.files
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        this.html5Reader(list[i], item)
                        this.files.unshift(item)
                    }
                }       
            },
            bkfileChangedz(i) {
                const list = this.$refs.file2[i].files
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        this.html5Reader(list[i], item)
                        this.files.unshift(item)
                    }
                }
            },
            bkfileChanged(i){
            	const list = this.$refs.file1[i].files
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        this.html5Reader(list[i], item)
                        this.files.unshift(item)
                    }
                }
            },
            fileChanged() {
                const list = this.$refs.file.files
                for (let i = 0; i < list.length; i++) {
                    if (!this.isContain(list[i])) {
                        const item = {
                            name: list[i].name,
                            size: list[i].size,
                            file: list[i]
                        }
                        this.html5Reader(list[i], item)
                        this.files.unshift(item)
                    }
                }
            },
            // 将图片文件转成BASE64格式
            html5Reader(file, item){
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.$set(item, 'src', e.target.result)
                }
                reader.readAsDataURL(file)
            },
            isContain(file) {
              return this.files.find((item) => item.name === file.name && item.size === file.size)
            },
            // isContainMusic(file) {
            //   return this.files.find((item) => item.name === file.name && item.size === file.size)
            // },
            // isContainVideo(file) {
            //   return this.files.find((item) => item.name === file.name && item.size === file.size)
            // },

            //获取库内图片资源
			get_image(){
				let _this = this;
				_this.files = []
				_this.$axios.post('getAllMedia',{
					type:'image',
					course_id:_this.list.course_id,
					package_id:_this.list.package_id
				}).then( res=>{
					if(res.data.code == 200){
						for(var i=0;i<res.data.data.length;i++){
							_this.files.push({
								id:res.data.data[i].id,
								src:res.data.data[i].res_url,
								url:'../../media/'+res.data.data[i].new_file_name
							})
						}
					}
					else{
						_this.$message.error(res.data.message)
					}
				})
			},
			get_music(){
				let _this = this;
				_this.files = []
				_this.$axios.post('getAllMedia',{
					type:'audio',
					course_id:_this.list.course_id,
					package_id:_this.list.package_id
				}).then( res=>{
					if(res.data.code == 200){
						for(var i = 0 ; i < res.data.data.length ; i ++){
							_this.files.push({
								id:res.data.data[i].id,
								name:res.data.data[i].media_title,
								file:{lastModifiedDate:res.data.data[i].updated_at},
								src:res.data.data[i].res_url,
								url:'../../media/'+res.data.data[i].new_file_name
							})
						}
					}
					else{
						_this.$message.error(res.data.message)
					}
				})
			},
			//获取库内视频资源
			get_video(){
				let _this = this;
				_this.files = []
				_this.$axios.post('getAllMedia',{
					type:'video',
					course_id:_this.list.course_id,
					package_id:_this.list.package_id
				}).then( res=>{
					if(res.data.code == 200){
						for(var i = 0 ; i < res.data.data.length ; i ++){
							_this.files.push({
								id:res.data.data[i].id,
								name:res.data.data[i].media_title,
								file:{lastModifiedDate:res.data.data[i].updated_at},
								src:res.data.data[i].res_url,
								url:'../../media/'+res.data.data[i].new_file_name
							})
						}
					}
					else{
						_this.$message.error(res.data.message)
					}
				})
			},

            playered(i){
				if(this.music_state){
					$('.upload-list-li').eq(i).find('.upload-list-li-name').find('.music_play_icon').find('.auto_audio').get(0).pause()
					this.music_state=0;
					$('.upload-list-li').eq(i).find('.upload-list-li-name').find('.music_play_icon').removeClass('zcir');

				}else{
					$('.upload-list-li').eq(i).find('.upload-list-li-name').find('.music_play_icon').find('.auto_audio').get(0).play().then((res)=>{
						this.music_state=1
						$('.upload-list-li').eq(i).find('.upload-list-li-name').find('.music_play_icon').addClass('zcir')
					})
					
				}				
			},
			bkplayer(i,j){
				if(this.music_state){
					$('.lesson_wrap').eq(i).find('.upload-list-li').eq(j).find('.music_play_icon').find('.auto_audio').get(0).pause()
					this.music_state=0;
					$('.lesson_wrap').eq(i).find('.upload-list-li').eq(j).find('.music_play_icon').removeClass('zcir');

				}else{
					$('.lesson_wrap').eq(i).find('.upload-list-li').eq(j).find('.music_play_icon').find('.auto_audio').get(0).play().then((res)=>{
						this.music_state=1
						$('.lesson_wrap').eq(i).find('.upload-list-li').eq(j).find('.music_play_icon').addClass('zcir')
					})
					
				}				
			},
			changecheckcolor(){
				if(this.value1){
					if(this.showPageDetal){
						this.xianshiA=true;
						this.xianshiB=false;
					}else{
						this.xianshiA=false;
						this.xianshiB=true;
					}
					$('.switch-D').animate({
						left:'19px'
					})
					$('.switch').addClass('switchB');
				}else{
					$('.switch-D').animate({
						left:'1px'
					})
					$('.switch').removeClass('switchB');
				}
			}
		},
		destroyed(){
		  window.removeEventListener('popstate', this.GoBack, false);
		},
		created(){
			const _this=this;
			this.course=JSON.parse(sessionStorage.getItem('courseNum'))[1]
			_this.list=JSON.parse(localStorage.getItem('template'));
			this.templateId=_this.list.creyId;
			this.ceryID=_this.list.teplatId;
			
			_this.get_image()
			_this.get_music()
			_this.get_video()
			var list = JSON.parse(sessionStorage.getItem('formID'));
			_this.$axios.post('findone',{
				to_id:list.conId
			}).then( res =>{
				if(res.data.code == 200){
					_this.showPage = res.data.data.json_data
					_this.moren=_this.showPage.bg_text
					this.value1=res.data.data.is_detail
					if(this.value1){
	           			_this.changecheckcolor()
	           			_this.xianshiA=true;
	           			_this.xianshiB=false;
	           			_this.$axios.post('showmodtwo',{to_id:list.conId}).then( res =>{
							if(res.data.code == 200){
								_this.toId=res.data.data[0].id;
	           					_this.twoPage=res.data.data[0].json_data.detal
							}
							else{
								_this.$message.error(res.data.message)
							}
						}).catch( error =>{
							console.log(error)
						})
	           		}else{
	           			_this.xianshiA=false;
	           			_this.xianshiB=true;
	           		}
				}
				else{
					_this.$message.error(res.data.message)
				}
			}).catch( error =>{
				console.log(error)
			})
		},
		watch:{
		}
	};
</script>
<style scoped>
	.content_wrap{
		width: 1152px;
		margin: 0 auto;
	}
	.content{
		width: 100%;
		box-sizing: border-box;
		background: #fff;
		margin-top: 20px;
		padding-bottom: 30px;
	}
	.tit{
		padding-left: 30px;
		font-size: 14px;
		color: #333;
		height: 64px;
		line-height: 64px;
		box-sizing: border-box;
		border-bottom: 1px solid #f5f5f5;
	}
	.inf_wrap{
		margin-top: 30px;
	}
	.from_tit,.from_tits{
		width: 293px;
		text-align: right;
		margin-right: 19px;
		font-size: 14px;
		line-height: 40px;
		float: left;
	}
	.from_ipt{
		width: 640px;
		float: left;
		border:1px solid #ddd;
		border-radius: 4px;
		
	}
	.from_ipt #ipt_tit{
		width: 100%;
		height: 40px;
		font-size: 14px;
		border:0;
		box-sizing: border-box;
		padding-left: 24px;
		background: #f5f5f5	;
		border-radius: 4px;
	}
	.from_text{
		width: 106px;
		height: 40px;
		background: #f5f5f5	;
		font-size: 14px;
		color: #999;
		line-height: 40px;
		text-align: center;
		cursor: pointer;
		position: relative;
	}
	.selct_con{
		width: 640px;
		height: 40px;
		/*background: #f5f5f5;*/
		position: relative;
		border:none;
	}
	.from_ipt .dis_ab,.abled,.from_ipt .dis_abl,.abled1{
		width: 60px;
		height: 40px;
		border:none;
		outline: none;
		line-height: 40px;
		padding-left: 18px;
		background: #f5f5f5;
	}
	.icons{
		position: absolute;
		top: 0px;
		right: 0px;
		color: #999;
		height: 100%;
		width: 60px;
		line-height: 34px;
		text-align: center;
	}
	.list_slts{
		box-sizing: border-box;
		display: none;
		position: absolute;
		z-index: 99999;
	}
	.list_slts li{
		width: 320px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		padding-left: 20px;
		background: #f5f5f5;
		border: 1px solid #ddd;
		border-top: 0;
	}
	.list_slts li:hover{
		background: #595db5;
		color: #fff;
	}
	.wb_txt{
		height: 340px;
	}
	.area_text,.area_text1{
		height: 120px;
		width: 640px;
		position: relative;
	}
	.area_text1{
		border: none;
	}
	.upload-videos-wrap{
		position: absolute;
		top: 29px;
		left: 210px;
		width: 83px;
		height: 20px;
	}
	.icon-video,.icon-img,.icon-music{
		background: url(../../../../static/imgs/icon_mp4.png) 0 0 no-repeat;
		width: 22px;
		height: 22px;
		background-size: 100%;	
		display: inline-block;
		margin-right: 3px;
		box-sizing: border-box;
		border:1px solid #fafafa;
	}
	.icon-img{
		background: url(../../../../static/imgs/icon_img.png) 0 0 no-repeat;
		margin-right: 0;
	}
	.icon-music{
		background: url(../../../../static/imgs/icon_mp3.png) 0 0 no-repeat;
	}
	.icon-img:hover,.icon-music:hover,.icon-video:hover{
		background-color: #fff5d4;
		border: 1px solid #dcac6c;
	}
	.area_text{
		border:0;
		height: 292px;
		width: 652px;
	}
	.img_bg{
		position: absolute;
		top: 0;
		right: -30px;
		width: 14px;
		height: 16px;
		background: url(../../../../static/imgs/icon_delete_gray.png) 0 0 no-repeat;
		background-size: 100%;
	}
	.area_text textarea,.area_text1 textarea{
		width: 640px;
		height: 120px;
		resize: none;
		box-sizing: border-box;
		padding: 13px 17px;
		font-size: 14px;
		border:0;
		background: #f5f5f5;
	}
	.from_switch{
		display: flex;
		align-items: center;
		height: 40px;
		width: 40px;
	}
	.new_add{
		color: #595db5;
		font-size: 14px;
		position: absolute;
		right:200px; 
		top: 0px;
		cursor: pointer;
	}
	.new_add i{
		
		font-weight: normal;
		font-size: 16px;
		color: #595db5;
	}
	.lesson_tit,.bkxq_tit{
		display: flex;
		justify-content: center;
		position: relative;
	}
	.tits{
		width: 111px;
		height: 40px;
		background: #e6e6e6;
		border-radius: 20px;
		line-height: 40px;
		text-align: center;
		position: relative;
	}
	.tits:before{
		position: absolute;
		content: "";
		top: 50%;
		left: -298px;
		width: 278px;
		height: 1px;
		background: #eee;
	}
	.tits:after{
		position: absolute;
		content: "";
		top: 50%;
		right: -298px;
		width: 278px;
		height: 1px;
		background: #eee;
	}
	.lesson_add{
		border:none;
		position: relative;
	}
	.preservaation{
		margin: 0 auto;
		margin-top: 16px;
		margin-bottom: 9px;
		color: #fff;
		font-size: 14px;
	}
	.preservaation-li{
		background: #f6f6f6;
		text-align: center;
		width: 100%;
		height: 100%;
	}
	.btn{
		display: inline-block;
		width: 110px;
		height: 36px;
		border-radius: 4px;
		cursor: pointer;
		background: #595db5;
		text-align: center;
		line-height: 36px;
	}
	.brn-back{
		background: #fff;
		border:1px solid #bfbfbf;
		color: #333;
		margin-left: 10px;
	}
	.preservaation-fixed{
		width: 100%;
		position: fixed;
		bottom: 0px;
		z-index: 999999;
		margin-bottom: 0;
		height: 50px;
		line-height: 50px;
	}
	.upload-list{
		width: 535px;
		border:none;
		margin: 0 auto;
	}
	.imgSrc{
		display: inline-block;
		vertical-align: middle;
		margin-right: 12px;
	}
	.auto_audio{
		opacity: 0;
		position: absolute;
		top: 10px;
		left: 0;
		width: 20px;
		height: 20px;
		z-index: -1;
	}
	.addnew_wrap{
		height: 40px;
		
	}
	.newadd{
		height: 38px;
		margin-bottom: 30px;
		color: #595db5;
		border: none;
		line-height: 38px;
	}
	.from-wrap-newadd{
		margin-top: 0;
	}
	.newitem{
		width: 110px;
		height: 38px;
	}
	.upload-list-li{position: relative;margin-top:5px;line-height: 40px;}
	.music_play_icon{position: absolute;top:10px;right: 0px;width: 20px;height: 20px;background: url(../../../../static/imgs/icon_music.png) 0 0 no-repeat;}
	.upload-list-li:hover{background-color: #f5f7fa;}
	.upload-list-li-name{position:relative;margin-right: 40px;display: block;}
	.fa-file-text-o{margin-right:7px;}
	.upload-list-li-label{margin-right: 11px;font-size: 16px;}
	.upload-list-li:hover .upload-list-li-label{color: #595db5;font-weight: bold;}
	.file-box{
		position: absolute;
		top: 0;
		left: 20px;
	    border-radius:3px;
	    color:#999;
	    display:inline-block;
	    line-height: 40px;
	}
	.file-btn,.files-btn,.files1-btn{
	    width: 100%;
	    height: 100%;
	    outline: none;
	    position: absolute;
	    top: 0;
	    left: -5%;
	    background-color: transparent;
	    filter:alpha(opacity=0);
	    -moz-opacity:0;
	    -khtml-opacity: 0;
	    opacity: 0;
	    cursor: pointer;
	}
	.clearboth::after{
	    content:"";
	    display:block;
	    clear:both;
	}
	.image-view{
	    width:640px;
	    height:136px;
	}
	.image-view .addbox{
	    float:left;
	    position:relative;
	    height:136px;
	    width:200px;
	    text-align:center;
	}
	.image-view .addbox input{
	    position:absolute;
	    left:0;
	    height:136px;
	    width:200px;
	    opacity:0;
	}
	.image-view .addbox .addbtn{
	    float:left;
	    height:136px;
	    width:200px;
	    color:#fff;
	    background:#f5f5f5;
	}
	.image-view .addbox .addbtn span{
		display: inline-block;
		width: 28px;
		height: 28px;
		color: #fff;
		background: #8b92cf;
		border-radius: 50%;
		line-height: 28px;
		font-size: 22px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
	}
	.image-view .item {
	    position:relative;
	    float:left;
	    height:136px;
	    width:200px;
	    margin: 0 10px 0 0;
	    overflow:hidden;
	}
	.image-view .item .cancel-btn{
	    position:absolute;
	    right:0;
	    top:0;
	    display:block;
	    width:20px;
	    height:20px;
	    color:#fff;
	    line-height:20px;
	    text-align:center;
	    background:red;
	    border-radius:10px;
	    cursor:pointer;
	}
	.image-view .item img{
	    width:100%;
	    height:100%;
	    object-fit: cover;
	}
	.image-view .view{
	    clear:both;
	}
	.lesson_wrap{
		padding-top: 30px;
	}

	.regIpt,.bk_ipt{
		position: relative;
	}
	.tishi{
        position: absolute;
        top:0px;
        right: -130px;
        width: 130px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }
    .per_tet{
        position: relative;
    }
    .per_err{
        color: #DC143C;
        position: absolute;
        top: 0px;
        right: 0px;
        display: none;
    }
    .per_suc{
        color:#00FF7F ;
        position: absolute;
        top: 0px;
        right:-20px;
        text-align: left;
        width: 100%;
        height: 100%;
        display: none;
    }

    .per_warn{
        color:#DC143C;
        position: absolute;
        top: 0px;
        right:-10px;
        text-align: left;
        width: 100%;
        height: 100%;
        display: none;
    }
	/*oss资源库*/
	.vue-oss-uploader-wrap{
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		width:100%;
		height: 100%;
		background: rgba(0,0,0,0.5);
	}
	.vue-oss-uploader{
		width: 846px;
		height: 538px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		background: #fff;
		border-radius: 10px;
	}
	.vue-oss-uploader-top{
		width:846px;
		height:50px;
		background:rgba(238,238,238,1);
		border-radius:10px 10px 0px 0px;
		position: relative;
	}
	.vue-oss-top-title{
		width:57px;
		height:50px;
		font-size:14px;
		line-height: 50px;
		margin-left: 23px;
		font-weight:400;
		color:rgba(0,0,0,1);
		float: left;
	}
	.vue-oss-top-button{
		float: right;
		width:90px;
		height:30px;
		background:rgba(89,93,181,1);
		border-radius:4px;
		color: #fff;
		font-size: 14px;
		line-height: 30px;
		text-align: center;
		margin-top: 11px;
		margin-right: 67px;
	}
	.vue-oss-top-close{
		width: 22px;
		height: 22px;
		color: #999;
		position: absolute;
		top: 50%;
		margin-top: -11px;
		right: 20px;
		border-radius: 50%;
		border:1px solid #999;
		font-size: 20px;
		line-height: 18px;
		text-align: center;
		box-sizing: border-box;
	}
	.clearfixed{
		clear: both;
		content: "";
		display: block;
		overflow: hidden;
	}
	.vue-oss-uploader-content{
		width: 100%;
		height: 44px;
		box-sizing: border-box;
		padding: 19px 24px;
	}
	.upload-button{
		width: 58px;
		padding-bottom: 5px;
		color: #999;
		text-align: center;
	}
	.upload-type-file{
		display: none;
	}
		/*oss资源库*/



		/*上传图片*/
	.vue-uploader .file-list:after {
	    content: '';
	    display: block;
	    clear: both;
	    visibility: hidden;
	    line-height: 0;
	    height: 0;
	    font-size: 0;
	}
	.vue-uploader .file-list .file-item {
	    float: left;
	    margin-right: 10px;
	    position: relative;
	    width:200px;
	    height: 136px;
	    justify-content: center;
	    display: flex;
	    align-items: center;
	}
	.vue-uploader .file-list .file-item img{
	    max-width: 200px;
	    max-height: 136px;
	}
	.vue-uploader .file-list .file-item .file-remove {
	    position: absolute;
	    right: 4px;
	    display: none;
	    top: 4px;
	    width: 20px;
	    height: 20px;
	    font-size:20px;
	    text-align: center;
	    color: white;
	    cursor: pointer;
	    line-height: 20px;
	    border-radius: 100%;
	    transform: rotate(45deg);
	    background: rgba(0, 0, 0, 0.5);
	}
	.vue-uploader .file-list .file-item:hover .file-remove {
	    display: inline;
	}
	.vue-uploader .file-list .file-item .file-name {
	    margin: 0;
	    height: 40px;
	    word-break: break-all;
	    font-size: 14px;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    display: -webkit-box;
	    -webkit-line-clamp: 2;
	    -webkit-box-orient: vertical;
	}
	.vue-uploader .upload-func {
	    display: flex;
	    padding: 10px;
	    margin: 0px;
	    background: #f8f8f8;
	    border-top: 1px solid #ececec;
	}
	.vue-uploader .upload-func .progress-bar {
	    flex-grow: 1;
	}
	.vue-uploader .upload-func .progress-bar section {
	    margin-top: 5px;
	    background: #00b4aa;
	    border-radius: 3px;
	    text-align: center; 
	    color: #fff;
	    font-size: 12px;
	    transition: all .5s ease;
	}
	.vue-uploader .upload-func .operation-box {
	    flex-grow: 0;
	    padding-left: 10px;
	}
	.vue-uploader .upload-func .operation-box button {
	    padding: 4px 12px;
	    color: #fff;
	    background: #007ACC;
	    border: none;
	    border-radius: 2px;
	    cursor: pointer;
	}
	.vue-uploader > input[type="file"] {
	    display: none;
	}
	.wb_picture img{
		display: inline-block;
	}

	/*上传图片*/



	/*上传视频*/
	/*.vue-oss-uploader-video-wrap,.vue-oss-uploader-video-wraps,.vue-oss-uploader-video-wrapw,.vue-oss-uploader-video-wrapm{
		width: 592px;
		height: 459px;
		border:1px solid #fafafa;
		position: fixed;
		top: 50%;
		left: 50%;
		background: #fff;
		transform: translateX(-50%) translateY(-50%);
		z-index: 1111;
		border: 1px solid rgba(0,0,0,0.2);
	}*/
	.vue-oss-uploader-video-wrapw,.vue-oss-uploader-video-wraps,.vue-oss-uploader-video-wrapm{
		display: none;
	}
	/*.vue-oss-uploader-video{
		position: relative;
		width: 100%;
		height: 100%;
	}*/
	.vue-oss-uploader-video-top{
		position: relative;
		border-bottom: 1px solid rgba(0,0,0,0.2);
	}
	.vue-oss-uploader-video-top-left{
		background: url(../../../../static/imgs/dialog-title-bg.png) repeat-x bottom;
		height: 26px;
		padding-left: 5px;
		line-height: 26px;
	}
	.vue-oss-top-closes{
		width: 20px ;
		height: 20px;
		position: absolute;
		right: 10px;
		top: 3px;
		border-radius: 50%;
		border: 1px solid rgba(0,0,0,0.2);
		cursor: pointer;
		box-sizing: border-box;
		text-align: center;
		line-height: 18px;
	}
	.vue-oss-top-closes:hover{
		background: #595db5;
		color: #fff;
	}
	.video-btn{
		width: 70px;
		height: 30px;
		background: #fafafa;
		border-radius: 4px;
		border:1px solid #fafafa;
		line-height: 30px;
		text-align: center;
		margin: 5px;
		background: url(../../../../static/imgs/dialog-title-bg.png) repeat-x bottom;
		cursor: pointer;
	}
	.vue-oss-uploader-video-content{
		width: 100%;
		height: 330px;
		overflow: auto;
	}
	.vue-oss-uploader-video-content::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.vue-oss-uploader-video-content::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.vue-oss-uploader-video-content::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.videoBtn{
		text-align: center;
		line-height: 32px;
		background: #595db5;
		color: #fff;
		cursor: pointer;
		height: 32px;
		width: 132px;
		margin: 0 auto;
	}
	.videoInput{
		width: 70px;
		height: 30px;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
	}
	.video-top-head{
		width: 580px;
		margin: 10px auto 0;
		height: 32px;
		background: #f4f4f4;
		font-size: 14px;
		color: #333;
	}
	.video-sele-z,.video-sele-num,.video-sele-time,.video-sele-m,.bk-video-sele-m{
		width: 90px;
		text-align: center;
		line-height: 32px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 0 5px
	}
	.video-sele-z,.video-sele-m,.bk-video-sele-m{
		position: relative;
	}
	.mark,.markmusic{
		width: 14px;
		height: 14px;
		line-height: 14px;
		color: #595DB5;
		position: absolute;
		top: 10px;
		left: 38px;
		display: none;
		z-index: 999;
	}
	.video-sele-name{
		color: #595DB5;
	}
	.video-sele-name,.video-sele-ntime{
		line-height: 32px;
		text-align: center;
		width: 174px;
		margin: 0 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.video-sele{
		text-align: center;
		line-height: 32px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		position: relative;
	}
	.checkedbox{
		width: 16px;
		height: 16px;
		border:1px solid #d3d5d9;
		display: inline-block;
		vertical-align: middle;
	}
	.oss-video{
		border:1px solid #f4f4f4;
		border-top: 0;
		width: 580px;
		margin: 0 auto;
		box-sizing: border-box;
		cursor: pointer;
		position: relative;
	}
	.image-show{
		width: 180px;
		height: 136px;
		cursor: pointer;
		margin-bottom: 20px;
		margin-left: 10px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.image-show img{
		max-width: 180px;
		max-height: 136px;
	}
	.image-show .mark{
		width: 180px;
		height: 136px;
		background: rgba(0,0,0,0.2);
		font-size: 40px;
		position: absolute;
		font-weight: 700;
		top: 0;
		left:0px;
		color: #fff;
		line-height: 136px;
		text-align: center;
	}
	.zcir{
		animation: go 1.5s infinite; 
		animation-fill-mode:both;
	}
	@keyframes go{
		0%{
			transform: rotateZ(0);
		}
		100%{
			transform: rotateZ(360deg);
		}
	}
	/*上传视频*/

	.videoInput{
		position: absolute;
		top: 31px;
		left: 7px;
		z-index: -1;
	}
	.switch,.addswitchwrap{
		position: relative;
		width: 40px;
		height: 20px;
		border-color: rgb(153, 153, 153);
    	background-color: rgb(153, 153, 153);
    	border-radius: 10px;
    	box-sizing: border-box;
    	border-width: 1px;
    	border-style: solid;
    	cursor: pointer;
	}
	.addchangewrap{
		position: absolute;
		bottom: 15px;
		left: 5px;
	}
	.switchB{
	    border-color: rgb(89, 93, 181);
		background-color: rgb(89, 93, 181)
	}
	.switch-D,.addclasswitch-D{
		position: absolute;
		content:"";
		top: 0;
		left: 1px;
		width: 18px;
		height: 18px;
		background: #fff;
		border-radius: 50%;
	}
	.loading-wrap,.loading-wrap1,.bkloading-wrap-music,.bkloading-wrap-video{
		width: 100%;
		height:32px;
		position: absolute;
		top: 0;
		left: 0;
		background: rgba(192,192,192,0.5);
		justify-content: center;
		align-items: center;
		display: none;
	}
	#progress_bar,#progress_bar1,.progress_barMusic,.progress_barVideo{
		width: 100%;
		height: 32px;
		background: rgb(192,192,192,0.5);	
	}
	.progress_length{
		width: 100%;
	}
	#progress_bar input,#progress_bar1 input,.progress_barMusic input,.progress_barVideo input{
		border:none;
		outline: none;
		height: 32px;
		width: 0;
		background: #595db5;
	}
	.uploadNum{
		position: absolute;
		top: 0;
		right: 0;
		line-height: 32px;
	}
	.videoBtn_wrap{
		position: absolute;
		bottom:20px;
		right: 20px;
		height: 32px;
		width: 132px;
	}
	.mark_btn{
		position: absolute;
		top: 0;
		left: 0;
		width: 132px;
		height: 32px;
		background: rgba(197,197,197,0.9);
		/* display: flex; */
		justify-content: center;
		align-items: center;
		cursor: not-allowed;
		display: none;
	}
	.mark_wrap_loading{
		position:absolute;
		top: 5px;
		left: 5px;
		background: transparent;
		width: 70px;
		height: 30px;
		cursor: not-allowed;
		display: none;
	}
	.oss-loading-mark-wrap{
		position:absolute;
		top: 0;
		left: 0;
		background: transparent;
		width: 100%;
		height: 100%;
		display: none;
		cursor: not-allowed;
	}
	.vue-oss-uploader-video-top-btn{
		position:relative;
	}


	/*进度条*/
	.loading_bar{position: absolute;top: 0;left: 0;width: 100%;height: 100%;background: rgba(255,255,255,0.6);display: none;}
	.progress_bar_load{line-height: 32px;}
	.progress_bar_div{border: none;line-height: 32px;background: #595db5;height: 32px;}
	.loading_upload_mark{position:absolute;top: 0px;left: 0px;background: transparent;width:100%;height:100%;cursor: not-allowed;}
</style>


// WEBPACK FOOTER //
// src/components/index/makFrom/formDate.vue